const EXTERNAL_LINKS = {
	tickets: "https://www.entrio.hr/event/weblica-konferencija-o-web-tehnologijama-16281",
	sessions: "https://sessionize.com/weblica-2024/",
}

const TRACK_BREAK = (duration) => {
	return {
		duration: duration || 15,
		break: true,
		title: {
			hr: "Pauza",
			en: "Break",
		}
	}
}

const LUNCH_BREAK = (duration) => {
	return {
		duration: duration || 60,
		break: true,
		lunch: true,
		title: {
			hr: "Ručak",
			en: "Lunch",
		},
		// description: {
		// 	hr: "",
		// 	en: ""
		// },
	}
}

module.exports = {
	currentYear: 2024,
	dateLimits: {
		ticketSales: {
			weblica: {
				from: null,
				to: "2024-05-10 23:59:59", // this needs to match latest ticket sale date & time
			}
		},
		lectureRegistration: {
			from: null,
			to: "2024-03-01 23:59:59",
		},
		workshopRegistration: {
			from: null,
			to: "2024-03-15 23:59:59",
		},
		teamRegistration: {
			from: null,
			to: "2024-04-30 23:59:59",
		},
		sponsorRegistration: {
			from: null,
			to: "2024-04-30 23:59:59",
		},
		exhibitorRegistration: {
			from: null,
			to: "2024-04-30 23:59:59",
		},
		pressRegistration: {
			from: null,
			to: "2024-04-30 23:59:59",
		},
		volunteerRegistration: {
			from: null,
			to: "2024-05-05 23:59:59",
		},
	},
	assets: {
		sponsorBrochure: {
			ident: {
				hr: "4d9hhgxx6jp8",
				en: "x9x552na5cdc",
			},
			enabled: false,
		},
		exhibitorBrochure: {
			ident: {
				hr: "bptmzfphkdxa",
				en: "jrckgktogfgc",
			},
			enabled: true,
		},
	},
	footerLinks: {
		code: {
			visible: true,
			extra: false,
			url: "/code",
			text: "more.code"
		},
		terms: {
			visible: true,
			extra: false,
			url: "/terms",
			text: "more.terms"
		},
		privacy: {
			visible: true,
			extra: false,
			url: "/privacy",
			text: "more.privacy"
		},
		recording: {
			visible: true,
			extra: false,
			url: "/recording",
			text: "more.recording"
		},
		safety: {
			visible: false,
			extra: true,
			url: "/safety",
			text: "more.safety"
		},
		press: {
			visible: true,
			extra: true,
			url: "/press",
			text: "more.press"
		},
		sponsor: {
			visible: true,
			extra: false,
			url: "/sponsors",
			text: "more.sponsor",
			dateLimit: "sponsorRegistration"
		},
		exhibitor: {
			visible: false,
			extra: false,
			url: "/exhibitors",
			text: "more.exhibitor",
			dateLimit: "exhibitorRegistration"
		},
		volunteer: {
			visible: true,
			extra: false,
			url: "/volunteer",
			text: "more.volunteer",
			dateLimit: "volunteerRegistration"
		}
	},
	events: {
		weblica: {
			tracks: ["track1", "track2"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: "2024-05-10 08:00:00",
			endDateTime: "2024-05-10 23:59:59",
			topicsTags: {
				hr: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
				en: [
					"<b>JavaScript</b>",
					"NodeJS",
					"Bun",
					"React",
					"Vue",
					"Ember",
					"Angular",
					"Svelte",
					"NextJS",
					"Gatsby",
					"NuxtJS",
					"...",
					"<b>PHP</b>",
					"Laravel",
					"Symphony",
					"CakePHP",
					"CodeIgniter",
					"Zend Framework",
					"...",
					"<b>.NET</b>",
					"Azure Cloud Development",
					"Xamarin",
					"Blazor",
					"ML.NET",
					"<b>Python</b>",
					"Flask",
					"Django",
					"CherryPy",
					"Bottle",
					"...",
					"Web",
					"APIs",
					"Services",
					"PWAs",
					"...",
					"<b>Security</b>",
					"OWASP",
					"PenTesting",
					"...",
					"UI",
					"UX",
					"...",
					"Git",
					"Docker",
					"DevOps",
					"Cloud",
					"...",
					"AI",
					"ChatBots",
					"LowCode/NoCode",
					"Blockchain",
					"...",
				],
			},
			menuItems: {
				about: {
					url: "/weblica#about",
					visible: false,
				},
				news: {
					url: "/weblica#news",
					visible: true,
				},
				speakers: {
					url: "/weblica#speakers",
					visible: true,
				},
				schedule: {
					url: "/weblica#schedule",
					visible: true,
				},
				tickets: {
					url: "/weblica#tickets",
					visible: false,
				},
				venue: {
					url: "/weblica#venue",
					visible: "active,before", // true || false || "active,before,after" (status dependant)
				},
				faq: {
					url: "/weblica#faq",
					visible: "active,before",
				},
				testimonials: {
					url: "/weblica#testimonials",
					visible: false,
				},
				sponsors: {
					url: "/weblica#sponsors",
					visible: true,
				},
			},
			buttons: {
				tickets: {
					title: "Get Tickets",
					url: "/weblica#tickets",
					hollow: false,
					external: false,
					visible: true,
					dateLimit: "ticketSales",
					floatingSpecial: {
						// used only on floating menu - if defined
						url: EXTERNAL_LINKS.tickets,
						external: true,
					},
				},
				lecture: {
					title: "Call for Speakers",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					dateLimit: "lectureRegistration",
				},
			},
			forcedButtons: {
				volunteer: {
					title: "Become a Volunteer",
					url: "/volunteer",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "volunteerRegistration",
				},
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: true,
					dateLimit: "sponsorRegistration",
				},
				exhibitor: {
					title: "Become an Exhibitor",
					url: "/exhibitors",
					hollow: true,
					external: false,
					visible: true,
					dateLimit: "exhibitorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					introImage: {
						file: "weblica-8105.jpg",
						// file: "weblica-7988.jpg",
						alt: "Weblica 2019",
					},
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "weblica-7573.jpg",
								alt: "Weblica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
						{
							width: "half",
							text: "txt_bbb",
						},
						{
							width: "half",
							image: {
								file: "weblica-7810.jpg",
								alt: "Weblica 2019",
							},
						},
						{
							width: "half",
							image: {
								file: "weblica-8036.jpg",
								alt: "Weblica 2019",
							},
						},
						{
							width: "half",
							text: "txt_ccc",
						},
					],
				},
				news: {
					visible: true,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				testimonials: {
					visible: true,
				},
				historyGallery: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
			},
			venue: {
				name: {
					hr: "Boksački klub Čakovec 1",
					en: "Boxing Club Čakovec 1"
				},
				nameAlt: {
					hr: "Boksački klub Čakovec 1",
					en: "Boxing Club Čakovec 1"
				},
				street: "Zagrebačka ulica 87",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38159, 16.415],
					zoom: 19,
				},
				mapImage: "boksacki-klub-map.png",
				mapUrl:
					"https://www.google.com/maps/place/Boksa%C4%8Dki+klub+%C4%8Cakovec+by+SB/@46.3812112,16.4155881,18z/data=!4m6!3m5!1s0x4768ad6f4f27b0d1:0x9e17db2042da7e34!8m2!3d46.3817288!4d16.4149579!16s%2Fg%2F11j6jm650y?entry=ttu",
				// openMapUrl: "https://www.openstreetmap.org/node/7289378820#map=19/46.38159/16.41500",
				images: [
					{
						title: "Prizemlje - Tlocrt",
						img: "weblica2024-prizemlje-tlocrt.jpg"
					},
					{
						title: "Prizemlje - 3D",
						img: "weblica2024-prizemlje-3d.jpg"
					},
					{
						title: "Kat - Tlocrt",
						img: "weblica2024-kat-tlocrt.jpg"
					},
					{
						title: "Kat - 3D #1",
						img: "weblica2024-kat-3d-1.jpg"
					},
					{
						title: "Kat - 3D #2",
						img: "weblica2024-kat-3d-2.jpg"
					},
				],
			},
			speakers: {
				"blau-frank": { // OK-LIVE - KEYNOTE #1
					keynote: true,
					image: "blau-frank.jpg",
					name: "Frank",
					surname: "Blau",
					contact: {
						email: "frank.blau@ebcont.com",
						phone: "+4366306601372",
					},
					position: {
						hr: "Principal Data Architect @ EBCONT",
						en: "Principal Data Architect @ EBCONT",
					},
					bio: {
						hr: "Frank Blau has been a Business Intelligence Data Architect for 15 years and has over 25 years of technical experience in relational and dimensional database technologies. He is currently a Principal Data Architect at EBCONT in Hard, Austria. He has been a developer, architect, analyst and educator in a variety of vertical markets and technologies. Frank has also been a consultant to Fortune 500 and mid-market companies in the use and implementation of data warehouse architectures, unstructured data, metadata management and analytic presentation.\r\n\r\nFrank is a 2018 and 2020 IBM Champion for Cloud and Blockchain, and was a 2014 IBM Champion for Information Management. He continues to provide thought leadership and research in such diverse areas as Streaming Data, Blockchain, Modern Data Architecture and Cloud Computing. Frank is also a public speaker and author on topics related to Business Intelligence, disruptive technologies, mobile computing and software methodologies and is also a member of the Digitale Initiativen in Dornbirn, Austria.",
						en: "Frank Blau has been a Business Intelligence Data Architect for 15 years and has over 25 years of technical experience in relational and dimensional database technologies. He is currently a Principal Data Architect at EBCONT in Hard, Austria. He has been a developer, architect, analyst and educator in a variety of vertical markets and technologies. Frank has also been a consultant to Fortune 500 and mid-market companies in the use and implementation of data warehouse architectures, unstructured data, metadata management and analytic presentation.\r\n\r\nFrank is a 2018 and 2020 IBM Champion for Cloud and Blockchain, and was a 2014 IBM Champion for Information Management. He continues to provide thought leadership and research in such diverse areas as Streaming Data, Blockchain, Modern Data Architecture and Cloud Computing. Frank is also a public speaker and author on topics related to Business Intelligence, disruptive technologies, mobile computing and software methodologies and is also a member of the Digitale Initiativen in Dornbirn, Austria.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/frank-blau/",
					},
				},
				"berecki-igor": { // OK-LIVE - KEYNOTE #2
					keynote: true,
					image: "berecki-igor.jpg",
					name: "Igor",
					surname: "Berecki",
					contact: {
						email: "igor.berecki@gmail.com",
						phone: "",
					},
					position: {
						hr: "Head of Staff @ Paediatric Intensive Care Unit",
						en: "Head of Staff @ Paediatric Intensive Care Unit",
					},
					bio: {
						hr: "Dr. med. Igor Berecki - Doc je autor brojnih fenomenalnih tekstova iz područja medicine (za Bug), enciklopedist čuvenog medicinskog biserja, kolekcionar ispijenog piva, influencer i zajebant, ali prije svega ljudina i pedijatar-intenzivist u KBC-u Osijek.",
						en: "Dr. med. Igor Berecki - Doc je autor brojnih fenomenalnih tekstova iz područja medicine (za Bug), enciklopedist čuvenog medicinskog biserja, kolekcionar ispijenog piva, influencer i zajebant, ali prije svega ljudina i pedijatar-intenzivist u KBC-u Osijek.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/igor-berecki-51b3824b",
					},
				},
				// "simic-bruno": { // ???
				// 	visible: false,
				// 	image: "simic-bruno.jpg",
				// 	name: "Bruno",
				// 	surname: "Šimić",
				// 	contact: {
				// 		email: "bruno@simicmail.com",
				// 		phone: "+385953536050",
				// 	},
				// 	position: {
				// 		hr: "",
				// 		en: "",
				// 	},
				// 	bio: {
				// 		hr: "",
				// 		en: "",
				// 	},
				// 	social: {
				// 		linkedIn: "",
				// 	},
				// },
				"begedin-nikola": { // OK-LIVE+++
					image: "begedin-nikola.jpg",
					name: "Nikola",
					surname: "Begedin",
					contact: {
						email: "begedinnikola@gmail.com",
						phone: "091 890 9997",
					},
					position: {
						hr: "Freelancer and full-stack developer @ V7Labs",
						en: "Freelancer and full-stack developer @ V7Labs",
					},
					bio: {
						// hr: "Počeo s .NET-om, dodao malo JS-a u mješavinu kako bi postao full stack, zatim prešao na Ruby on Rails s Emberom, ubrzo zamijenio Elixirom u backendu i zapravo svime na frontendu (trenutačno Vue).",
						hr: "Started with .NET, added some JS to the mix, to become full stack, then shifted to Ruby on Rails with Ember, soon replaced by Elixir on backend and basically anything on the frontend (currently Vue).",
						en: "Started with .NET, added some JS to the mix, to become full stack, then shifted to Ruby on Rails with Ember, soon replaced by Elixir on backend and basically anything on the frontend (currently Vue).",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/nikola-begedin-54541036/",
					},
				},
				"matijanic-borna": { // OK-LIVE+++
					image: "matijanic-borna.jpg",
					name: "Borna",
					surname: "Matijanić",
					contact: {
						email: "borna.m@netgen.io",
						phone: "091 735 3553",
					},
					position: {
						hr: "Backend developer @ Netgen",
						en: "Backend developer @ Netgen",
					},
					bio: {
						// hr: "PHP/Symfony developer, diplomirao informatiku na Fakultetu elektrotehnike, računarstva i informacijskih tehnologija Osijek. Bavi se web stvarima 6 godina. Radi u Netgenu kao backend developer i voditelj podružnice. Promicatelj Slavonije.",
						hr: "PHP/Symfony developer, graduated Informatics at Faculty of Electrical Engineering, Computer Science and Information Technology Osijek. Doing web stuff for 6 years. Works at Netgen as backend developer and branch manager. Slavonia evangelist.",
						en: "PHP/Symfony developer, graduated Informatics at Faculty of Electrical Engineering, Computer Science and Information Technology Osijek. Doing web stuff for 6 years. Works at Netgen as backend developer and branch manager. Slavonia evangelist.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/borna-matijani%C4%87-6007b992/",
					},
				},
				"bronzin-tomislav": { // OK-LIVE+++
					image: "bronzin-tomislav.jpg",
					name: "Tomislav",
					surname: "Bronzin",
					contact: {
						email: "tbronzin@citus.hr",
						phone: "+385912019443",
					},
					position: {
						hr: "CEO @ CITUS / Microsoft Regional Director & MVP",
						en: "CEO @ CITUS / Microsoft Regional Director & MVP",
					},
					bio: {
						// hr: "Tomislav Bronzin je regionalni direktor Microsofta i Microsoftov najvrjedniji stručnjak (19. godina zaredom!) - M365 Apps & Services/Business Applications i osnivač CITUS-a, Microsoft Silver Partner, specijalizirane za razvoj softvera, savjetovanje i obuku. Vodi CITUS tim i upravlja projektima usmjerenim na Microsoft365, Power Platform, Mixed Reality, AI, Big Data & Cloud Computing. Tomislav je trener i govornik na Microsoftovim konferencijama kao što su TechEd Europe, WindDays, NT Konferenca, MS NetWork, CrisCon, Weblica, KulenDayz, Init Conference itd. Predaje na nekoliko sveučilišta i mentor je studentskim timovima za Imagine Cup Competition. Tomislav je organizirao http://www.mobilityday.com konferenciju (10 godina zaredom!) i pomaže u organizaciji jedne od najvećih MS Community konferencija u regiji - KulenDayz. Tomislav je jedan od osnivača MS Community-a u Hrvatskoj i potpredsjednik Udruženja informatike Hrvatske gospodarske komore. Također je poduzetnik i inovator koji je (sa svojim timom) osvojio preko 90 međunarodnih nagrada za svoje izume u IT-u, pet patenata i mnoga druga priznanja. Tomislav je vodio CITUS tim u razvoju brojnih inovativnih softverskih proizvoda temeljenih na primjerenim inovacijama u mješovitoj stvarnosti, umjetnoj inteligenciji, velikim podacima i računalstvu u oblaku.",
						hr: "Tomislav Bronzin is Microsoft Regional Director & Microsoft Most Valuable Professional (19th year in a row!) - M365 Apps & Services/Business Applications and founder of CITUS, a Microsoft Silver Partner Company specializing in software development, consulting, and training. He is leading CITUS Team, and managing projects focused on Microsoft365, Power Platform, Mixed Reality, AI, Big Data & Cloud Computing. Tomislav is a trainer and speaker at Microsoft conferences like TechEd Europe, WindDays, NT Konferenca, MS NetWork, CrisCon, Weblica, KulenDayz, Init Conference, etc. He teaches at several universities and mentors student teams for Imagine Cup Competition. Tomislav organized the http://www.mobilityday.com conference (10 years in a row!) and is helping to organize one of the largest MS Community Conferences in the region - KulenDayz. Tomislav is one of the founders of MS Community in Croatia and the Croatian Chamber of Economy IT Association Vice President. He is also an entrepreneur and innovator that (with his team) has won over 90 international awards for his invention in IT, five patents, and many other recognitions. Tomislav has led CITUS Team in developing numerous innovative software products based on propriety innovations in mixed reality, artificial intelligence, big data, and cloud computing.",
						en: "Tomislav Bronzin is Microsoft Regional Director & Microsoft Most Valuable Professional (19th year in a row!) - M365 Apps & Services/Business Applications and founder of CITUS, a Microsoft Silver Partner Company specializing in software development, consulting, and training. He is leading CITUS Team, and managing projects focused on Microsoft365, Power Platform, Mixed Reality, AI, Big Data & Cloud Computing. Tomislav is a trainer and speaker at Microsoft conferences like TechEd Europe, WindDays, NT Konferenca, MS NetWork, CrisCon, Weblica, KulenDayz, Init Conference, etc. He teaches at several universities and mentors student teams for Imagine Cup Competition. Tomislav organized the http://www.mobilityday.com conference (10 years in a row!) and is helping to organize one of the largest MS Community Conferences in the region - KulenDayz. Tomislav is one of the founders of MS Community in Croatia and the Croatian Chamber of Economy IT Association Vice President. He is also an entrepreneur and innovator that (with his team) has won over 90 international awards for his invention in IT, five patents, and many other recognitions. Tomislav has led CITUS Team in developing numerous innovative software products based on propriety innovations in mixed reality, artificial intelligence, big data, and cloud computing.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/tbronzin/",
					},
				},
				"miodragovic-jelena": { // OK-LIVE+++
					image: "miodragovic-jelena.jpg",
					name: "Jelena",
					surname: "Miodragović",
					contact: {
						email: "jelena-miodragovic@live.com",
						phone: "+38765271124",
					},
					position: {
						hr: "Software Engineer @ Diplomat Tech",
						en: "Software Engineer @ Diplomat Tech",
					},
					bio: {
						// hr: "Jelena Miodragović magistrirana softverska inženjerka u tvrtki Infopuls, s fokusom na front-end tehnologije. Ona je regionalni govornik i bivši Microsoftov najvrjedniji stručnjak (MVP). Vrlo aktivna u IT zajednici kao suvoditelj BLbit korisničke grupe u Banja Luci i suorganizator IT konferencije INIT.",
						hr: "Jelena Miodragovic is M.Eng(IT) and Software Engineer, with focus on FrontEnd technologies. She is regional speaker and Microsoft Most Valuable Professional (MVP). Very active in IT community as a CO-leader of BLbit user group in Banja Luka and CO-organizer of IT conference INIT.",
						en: "Jelena Miodragovic is M.Eng(IT) and Software Engineer, with focus on FrontEnd technologies. She is regional speaker and Microsoft Most Valuable Professional (MVP). Very active in IT community as a CO-leader of BLbit user group in Banja Luka and CO-organizer of IT conference INIT.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/jelenamiodragovic/",
					},
				},
				"cosic-ratko": { // OK-LIVE+++
					image: "cosic-ratko.jpg",
					name: "Ratko",
					surname: "Ćosić",
					contact: {
						email: "ratko_cosic@hotmail.com",
						phone: "+385981384724",
					},
					position: {
						hr: "Senior Software Architect",
						en: "Senior Software Architect",
					},
					bio: {
						// hr: "Ratko je viši softverski arhitekt s više od 20 godina profesionalnog rada u istraživanju, dizajnu i razvoju poslovnih sustava, uglavnom na Microsoft platformi. Područja stručnosti uključuju komunikacijske sustave, ERP i UX proizvode koji se temelje na računalstvu u oblaku i srodnim obrascima arhitekture (mikro-servisi, SPA, serverless, IoT). Također, na poziciji mentora i tehničkog voditelja. U slobodno vrijeme drži predavanja na regionalnim IT konferencijama.",
						hr: "Ratko is a senior software architect with more than 20 years of professional work in research, design and developing business systems, mostly on Microsoft platform. Areas of expertise include communication systems, ERP and UX products based on Cloud computing and related architecture patterns (microservices, SPAs, serverless, IoT). Also, in position of a mentor and a tech lead. In spare time, giving lectures at regional IT conferences.",
						en: "Ratko is a senior software architect with more than 20 years of professional work in research, design and developing business systems, mostly on Microsoft platform. Areas of expertise include communication systems, ERP and UX products based on Cloud computing and related architecture patterns (microservices, SPAs, serverless, IoT). Also, in position of a mentor and a tech lead. In spare time, giving lectures at regional IT conferences.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/ratko-cosic",
					},
				},
				"peharda-luka": { // OK-LIVE+++
					image: "peharda-luka.jpg",
					name: "Luka",
					surname: "Peharda",
					contact: {
						email: "luka.peharda@gmail.com",
						phone: "+385989362480",
					},
					position: {
						hr: "Developer who transforms todos into tadas!",
						en: "Developer who transforms todos into tadas!",
					},
					bio: {
						// hr: "PHP & JS programer s više od 10 godina iskustva.",
						hr: "PHP & JS developer with over 10 years of experience.",
						en: "PHP & JS developer with over 10 years of experience.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/lukapeharda/",
					},
				},
				"vidovic-filip": { // OK-LIVE+++
					image: "vidovic-filip.jpg",
					name: "Filip",
					surname: "Vidović",
					contact: {
						email: "fvidovic@ekobit.hr",
						phone: "+385981376904",
					},
					position: {
						hr: "Developer @ Ekobit",
						en: "Developer @ Ekobit",
					},
					bio: {
						hr: "Filip Vidović programiranjem se bavi od tinejđerskih dana, a u Ekobitu je od 2020. godine. Sudjelovao je na raznim projektima u timovima raznih veličina, a većinu karijere proveo je na izradi softver podrške u telemedicini (Rods&Cones). Slobodno vrijeme troši na društvene igre i košarku (kad se ekipa uspije skupiti).",
						en: "Filip Vidović programiranjem se bavi od tinejđerskih dana, a u Ekobitu je od 2020. godine. Sudjelovao je na raznim projektima u timovima raznih veličina, a većinu karijere proveo je na izradi softver podrške u telemedicini (Rods&Cones). Slobodno vrijeme troši na društvene igre i košarku (kad se ekipa uspije skupiti).",
						// en: "Filip Vidović has been programming since his teenage days, and has been at Ekobit since 2020. He participated in various projects in teams of various sizes, and most of his career was spent developing telemedicine support software (Rods&Cones). He spends his free time playing board games and basketball (when the team manages to get together).",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/filip-vidovi%C4%87-a183851b8/",
					},
				},
				"peric-mazar-antonio": { // OK-LIVE+++
					image: "peric-mazar-antonio.jpg",
					name: "Antonio",
					surname: "Perić-Mažar",
					contact: {
						email: "antonio@locastic.com",
						phone: "+38598813684",
					},
					position: {
						hr: "CEO @ Locastic",
						en: "CEO @ Locastic",
					},
					bio: {
						// hr: "Antonio Perić-Mažar je direktor digitalne agencije Locastic sa sjedištem u prekrasnom hrvatskom gradu Splitu. Njihov glavni fokus je izgradnja složenih mobilnih i web platformi za različite klijente koji se kreću od startupa do poslovnih kompanija iz cijelog svijeta.\r\n\r\nOn je ponosni backend programer koji je prešao na menadžersku ulogu nakon osnivanja Locastica u 2011., jer je u vrlo kratkom vremenu tim narastao i postali su vrlo popularni u razvojnom svijetu.\r\n\r\nOn je prilično proaktivan tip - jer je jedan od osnivača najveće regionalne Blockchain konferencije, domaćin je besplatnog mjesečnog Meetup događaja u Splitu, a nedavno se zaljubio i u Esports jer je vlasnik najboljeg hrvatskog Counter-Strike tima.\r\n\r\nPosljednjih nekoliko godina Antonio se fokusirao i na dijeljenje svog znanja o poslovanju i razvoju sa startupima i drugim poduzetnicima te je govorio na mnogim konferencijama.",
						hr: "Antonio Perić-Mažar is CEO at Locastic digital agency, based in beautiful Croatian city called Split. Their main focus is to build complex mobile and web platforms for different clients that range from startups to enterprise companies from all over the globe.\r\n\r\nHe is a proud backend developer that moved into a managerial role after founding Locastic in 2011, since, in a very short period of time the team has grown and they became very popular in the development world.\r\n\r\nHe is quite a proactive guy - as he is one of the founders of the largest regional Blockchain Conference, he is hosting a free monthly Meetup event in Split, also recently he fell in love with Esports as he owns the best Croatian Counter-Strike team.\r\n\r\nDuring the last few years Antonio also focused on sharing his business and development knowledge with Startups and other Entrepreneurs and he spoke on many conferences.",
						en: "Antonio Perić-Mažar is CEO at Locastic digital agency, based in beautiful Croatian city called Split. Their main focus is to build complex mobile and web platforms for different clients that range from startups to enterprise companies from all over the globe.\r\n\r\nHe is a proud backend developer that moved into a managerial role after founding Locastic in 2011, since, in a very short period of time the team has grown and they became very popular in the development world.\r\n\r\nHe is quite a proactive guy - as he is one of the founders of the largest regional Blockchain Conference, he is hosting a free monthly Meetup event in Split, also recently he fell in love with Esports as he owns the best Croatian Counter-Strike team.\r\n\r\nDuring the last few years Antonio also focused on sharing his business and development knowledge with Startups and other Entrepreneurs and he spoke on many conferences.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/antonioperic/",
					},
				},
				"jelich-noah": { // OK-LIVE+++
					image: "jelich-noah.jpg",
					name: "Noah",
					surname: "Jelich",
					contact: {
						email: "sessionize749@registrar813.fastmail.com",
						phone: "+385913616989",
					},
					position: {
						hr: "Lead Security Researcher @ Hacken",
						en: "Lead Security Researcher @ Hacken",
					},
					bio: {
						// hr: "Tehnički voditelj i stručnjak u sigurnosnim istraživanjima, full stack softverskom inženjerstvu i razvoju blockchaina:\r\n\r\n Vješt u Rustu, Typescriptu, Solidityju i Pythonu sa snažnim temeljima u načelima informacijske sigurnosti.\r\n\r\nRedovito govori na konferencijama i panelima o temama vezanim uz sigurnost blockchaina.\r\n\r\nAktivan suradnik na projektima otvorenog koda putem izvješća o pogreškama, doprinosa kodu, pregleda koda, trijaže i rješavanja problema, te je stručnjak u dizajnu i korisničkom iskustvu.\r\n\r\nCjeloživotna strast za tehnologijom potaknuta je ranom fascinacijom računalima, igranjem i modificiranjem Minecrafta.",
						hr: "Technical lead with expertise in security research, full stack software engineering, and blockchain development:\r\n\r\nProficient in Rust, Typescript, Solidity, and Python with a strong foundation in information security principles.\r\n\r\nRegularly speaks at conferences and panels on topics related to blockchain security.\r\n\r\nActive contributor to open-source projects through bug reports, code contributions, code review, issue triaging, and resolution, as well as design and user experience expertise.\r\n\r\nLifelong passion for technology, sparked by early fascination with computers, gaming, and Minecraft modding.",
						en: "Technical lead with expertise in security research, full stack software engineering, and blockchain development:\r\n\r\nProficient in Rust, Typescript, Solidity, and Python with a strong foundation in information security principles.\r\n\r\nRegularly speaks at conferences and panels on topics related to blockchain security.\r\n\r\nActive contributor to open-source projects through bug reports, code contributions, code review, issue triaging, and resolution, as well as design and user experience expertise.\r\n\r\nLifelong passion for technology, sparked by early fascination with computers, gaming, and Minecraft modding.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/njelich/",
					},
				},
				"fusic-duro": { // OK-LIVE+++
					image: "fusic-duro.jpg",
					name: "Đuro",
					surname: "Fusić",
					contact: {
						email: "duro.fusic@outlook.com",
						phone: "385923722631",
					},
					position: {
						hr: "Senior Javascript Developer @ Comsysto Reply",
						en: "Senior Javascript Developer @ Comsysto Reply",
					},
					bio: {
						// hr: "Programer zadnjih 7 godina s glavnim fokusom na Front-end tehnologije. Voli se baviti opskurnim značajkama preglednika kojih većina ljudi nije svjesna. U slobodno vrijeme voli trčati i baviti se glazbenom produkcijom i DJ-ingom.",
						hr: "Developer for the past 7 years with main focus being the Front-end technologies. Likes to dwell into obscure features of the browsers that most of the people are unaware of. In the free time likes to run and dabble into music production and DJ'ing.",
						en: "Developer for the past 7 years with main focus being the Front-end technologies. Likes to dwell into obscure features of the browsers that most of the people are unaware of. In the free time likes to run and dabble into music production and DJ'ing.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/dfusic/",
					},
				},
				"crnkovic-andrei-zvonimir": { // OK-LIVE+++
					image: "crnkovic-andrei-zvonimir.jpg",
					name: "Andrei Zvonimir",
					surname: "Crnković",
					contact: {
						email: "andrei@0x7f.dev",
						phone: "00385976309118",
					},
					position: {
						hr: "Freelance Elixir Developer @ 0x7f Inc.",
						en: "Freelance Elixir Developer @ 0x7f Inc.",
					},
					bio: {
						// hr: "Programer sam već 12 godina. Radio sam s JavaScriptom, Pythonom, Golangom, a sada i Elixirom.\r\n\r\nNeki od mojih najznačajnijih projekata i klijenata uključuju: WB Games New York, Disney Cruise Line Industries i Contractbook. Za njih sam pomogao razviti širok raspon proizvoda, od javnih do internih alata za programere.\r\n\r\nMoja supruga i ja također imamo svoju računovodstvenu tvrtku, SmartAccount, namijenjenu pomoći hrvatskim freelancerima i programerima da imaju bolji i jeftiniji način obavljanja službenih poreznih i regulatornih poslova. Usredotočeni smo na oslobađanje informacija za sustave plaćanja i konzultantske tvrtke, pokušavajući vratiti znanje u zajednicu putem sponzoriranja događaja, postova na blogovima i biltena. Radimo i besplatno porezno savjetovanje za one kojima je to potrebno.\r\n\r\nU slobodno vrijeme pomažem u organizaciji najveće istočnoeuropske OpenSource konferencije DORS/CLUC koja traje već 30 godina. Povrh održavanja manjih susreta programera u Zagrebu.",
						hr: "I've been a software developer for 12 years to date. I've worked with JavaScript, Python, Golang, and now Elixir.\r\n\r\nSome of my most notable projects and clients include: WB Games New York, Disney Cruise Line Industries, and Contractbook. For them I've helped develop a large range of products, from public facing to internal developer tooling.\r\n\r\nMy wife and me also have our own Accounting firm, SmartAccount, intended to help Croatian freelancers and developers have a better and cheaper way of handling official tax and regulation work. We're focused on liberating information for paywalls and consultancy firms, trying to put the knowledge back into the community via sponsoring events, blog posts, and newsletters. We also do free tax consultations for those who need it.\r\n\r\nAnd in my free time, I help out with organising the largest East Europe OpenSource conference DORS/CLUC that has been active for 30 years now. On top of hosting smaller developer meetups in Zagreb.",
						en: "I've been a software developer for 12 years to date. I've worked with JavaScript, Python, Golang, and now Elixir.\r\n\r\nSome of my most notable projects and clients include: WB Games New York, Disney Cruise Line Industries, and Contractbook. For them I've helped develop a large range of products, from public facing to internal developer tooling.\r\n\r\nMy wife and me also have our own Accounting firm, SmartAccount, intended to help Croatian freelancers and developers have a better and cheaper way of handling official tax and regulation work. We're focused on liberating information for paywalls and consultancy firms, trying to put the knowledge back into the community via sponsoring events, blog posts, and newsletters. We also do free tax consultations for those who need it.\r\n\r\nAnd in my free time, I help out with organising the largest East Europe OpenSource conference DORS/CLUC that has been active for 30 years now. On top of hosting smaller developer meetups in Zagreb.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/andreicek/",
					},
				},
				"saric-marko": { // OK-LIVE+++
					image: "saric-marko.jpg",
					name: "Marko",
					surname: "Šarić",
					contact: {
						email: "marko.saric@icloud.com",
						phone: "0994614512",
					},
					position: {
						hr: "Lead Software Engineer @ GlobalLogic",
						en: "Lead Software Engineer @ GlobalLogic",
					},
					bio: {
						hr: "Marko se bavi razvojem aplikacija, DevOps procesima te je bloger i predavač na različitim community događanjima. Primarno radi rješenja na Microsoft Stacku za Web, mobilne i Azure aplikacije. \r\n\r\nKroz karijeru radio je na različitim projektima za domaće i inozemne klijente, te održao predavanja na nekoliko domaćih konferencija. Nositelj je nekoliko Microsoftovih certifikata na području Web Application Developmenta-a, Cloud Platform and Application Lifecycle Management-a. \r\n\r\nRadio je u različitim ulogama u projektnim timovima, od developera do team leadera i DevOps konzultanta pomažući organizacijama u kreiranju DevOps kulture i implementaciji Application Lifecycle Management procesa. \r\n\r\nVeliki je ljubitelj Apple eko-sustava, te obožava isprobavati različita Microsoftova rješenja na macOS-u. Kada je udaljen od računala bavi se brdskim biciklom ili pak rasteže prste na gitari.\r\n",
						en: "Marko se bavi razvojem aplikacija, DevOps procesima te je bloger i predavač na različitim community događanjima. Primarno radi rješenja na Microsoft Stacku za Web, mobilne i Azure aplikacije. \r\n\r\nKroz karijeru radio je na različitim projektima za domaće i inozemne klijente, te održao predavanja na nekoliko domaćih konferencija. Nositelj je nekoliko Microsoftovih certifikata na području Web Application Developmenta-a, Cloud Platform and Application Lifecycle Management-a. \r\n\r\nRadio je u različitim ulogama u projektnim timovima, od developera do team leadera i DevOps konzultanta pomažući organizacijama u kreiranju DevOps kulture i implementaciji Application Lifecycle Management procesa. \r\n\r\nVeliki je ljubitelj Apple eko-sustava, te obožava isprobavati različita Microsoftova rješenja na macOS-u. Kada je udaljen od računala bavi se brdskim biciklom ili pak rasteže prste na gitari.\r\n",
						// en: "Marko deals with application development, DevOps processes and is a blogger and lecturer at various community events. Primarily works on Microsoft Stack solutions for Web, mobile and Azure applications. \r\n\r\nThroughout his career, he worked on various projects for domestic and foreign clients, and gave lectures at several domestic conferences. He holds several Microsoft certificates in the field of Web Application Development, Cloud Platform and Application Lifecycle Management. \r\n\r\nHe has worked in various roles in project teams, from developers to team leaders and DevOps consultants helping organizations create a DevOps culture and implement Application Lifecycle Management processes. \r\n\r\nHe is a big fan of the Apple eco-system, and loves to try different Microsoft solutions on macOS. When he is away from the computer, he does mountain biking or stretches his fingers on the guitar.\r\n",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/saricmarko/",
					},
				},
				"voska-filip": { // OK-LIVE+++
					image: "voska-filip.jpg",
					name: "Filip",
					surname: "Voska",
					contact: {
						email: "filip.voska@gmail.com",
						phone: "0918957913",
					},
					position: {
						hr: "JavaScript Team Lead @ Infinum",
						en: "JavaScript Team Lead @ Infinum",
					},
					bio: {
						hr: "Filip graduated from Faculty of Electrical Engineering and Computing, University of Zagreb in 2017 and has started his career at Infinum as JavaScript Engineer. Over the years, FIlip gathered knowledge of various Frontend topics, with focus on Angular, and became Angular Lead Engineer.<br/><br/>Some more time passed and Filip started focusing more on soft-skills and became JavaScript Team Lead at Infinum, while still continuing to do Angular development and being involved in architecture-level decision-making.<br/><br/>As for FIlip's personal interests and hobbies, he likes PC/Nintendo Switch Gaming, messing around with HiFi gear and mechanical keyboards, and being a loving husband & father to his wife & child.",
						en: "Filip graduated from Faculty of Electrical Engineering and Computing, University of Zagreb in 2017 and has started his career at Infinum as JavaScript Engineer. Over the years, FIlip gathered knowledge of various Frontend topics, with focus on Angular, and became Angular Lead Engineer.<br/><br/>Some more time passed and Filip started focusing more on soft-skills and became JavaScript Team Lead at Infinum, while still continuing to do Angular development and being involved in architecture-level decision-making.<br/><br/>As for FIlip's personal interests and hobbies, he likes PC/Nintendo Switch Gaming, messing around with HiFi gear and mechanical keyboards, and being a loving husband & father to his wife & child.",
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/filip-voska-682170b0",
					},
				},
				"hrncic-marko": { // OK-LIVE+++
					image: "hrncic-marko.jpg",
					name: "Marko",
					surname: "Hrnčić",
					contact: {
						email: "mahrncic@gmail.com",
						phone: "0995706105"
					},
					position: {
						hr: ".NET Team Lead @ Infinum",
						en: ".NET Team Lead @ Infinum"
					},
					bio: {
						// hr: "Softverski entuzijast s 5+ godina profesionalnog iskustva u razvoju softvera.\r\n\r\nTrenutno radi kao vođa backend tima u Infinumu, usmjerava druge inženjere i potiče osobni rast kroz kontinuirano učenje i razvoj. Softverska arhitektura i tehnologije orijentirane na oblak kao što su Azure i AWS veliki su fokus u mojoj karijeri. \r\n\r\nTakođer me zanima čisti kod i performanse u softveru, tako da sam sklon istraživanju tih tema u slobodno vrijeme, osim gledanja nogometa.",
						hr: "Software enthusiast with 5+ years of professional experience in software development.\r\n\r\nCurrently working as a backend team lead at Infinum, directing other engineers and fostering personal growth through continuous learning and development. Software architecture and cloud-oriented technologies like Azure and AWS are of great focus in my career. \r\n\r\nI'm also interested in clean code and performance in software, so I tend to research those topics in my free time, apart from watching football.",
						en: "Software enthusiast with 5+ years of professional experience in software development.\r\n\r\nCurrently working as a backend team lead at Infinum, directing other engineers and fostering personal growth through continuous learning and development. Software architecture and cloud-oriented technologies like Azure and AWS are of great focus in my career. \r\n\r\nI'm also interested in clean code and performance in software, so I tend to research those topics in my free time, apart from watching football."
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/marko-hrncic/"
					},
				},
				"culjak-ivan": { // OK-LIVE+++
					image: "culjak-ivan.jpg",
					name: "Ivan",
					surname: "Čuljak",
					contact: {
						email: "ivan@culjak.xyz",
						phone: "+385914404403"
					},
					position: {
						hr: "Cloud Whisperer @ Cloudlet Ltd",
						en: "Cloud Whisperer @ Cloudlet Ltd"
					},
					bio: {
						hr: "A developer evolved into an architect. Loved salvaging wrecks, now enjoys correcting the course well before the wreck happens. Keeps postponing releasing his SaaS and podcast.",
						en: "A developer evolved into an architect. Loved salvaging wrecks, now enjoys correcting the course well before the wreck happens. Keeps postponing releasing his SaaS and podcast."
					},
					social: {
						linkedIn: "https://www.linkedin.com/in/ivandothr/"
					},
				},
				"novak-josip": { // OK-LIVE+++
					image: "novak-josip.jpg",
					name: "Josip",
					surname: "Novak",
					contact: {
						email: "josip.novak@hiwe-it.com",
						phone: "+385994418008"
					},
					position: {
						hr: "Software Developer @ HIWE-IT",
						en: "Software Developer @ HIWE-IT"
					},
					bio: {
						hr: "Experienced in the alchemical transformation of caffeine into code.",
						en: "Experienced in the alchemical transformation of caffeine into code."
					},
					social: {
						linkedIn: "" // no profile
					},
				},
				"bistrovic-jurica": { // OK-LIVE+++
					image: "bistrovic-jurica.jpg",
					name: "Jurica",
					surname: "Bistrović",
					contact: {
						email: "jurica.bistrovic@hiwe-it.com",
						phone: "+385955097562"
					},
					position: {
						hr: "Software Developer @ HIWE-IT",
						en: "Software Developer @ HIWE-IT"
					},
					bio: {
						hr: "Raised by technology.",
						en: "Raised by technology."
					},
					social: {
						linkedIn: "" // no profile
					},
				},
			},
			sessions: [
				{ // OK-LIVE - KEYNOTE-1
					ident: "keynote-blau",
					duration: 30,
					language: "en",
					keynote: true,
					title: {
						hr: "A McLuhan-based approach to data architecture",
						en: "A McLuhan-based approach to data architecture",
					},
					description: {
						hr: "When Marshall McLuhan said in 1964 that “the medium is the message”, he was primarily speaking about the mediums of print, radio and television. As our industry grows in volume, variety and velocity, this statement remains an important touchpoint for examining our goals and how we create and investigate the content and structures that confront us today. Importantly, the industrial world today functions in what we observe to be a mullti-model ecosystem, with significant needs for harmonization and analytics. What we have learned is that in order to both understand and derive actionable insight from this dynamic world requires the adoption of multi-model techniques and platforms. In this presentation, this evolution and an approach to implementation is outlined and described as an extension of McLuhan’s statement, providing crucial grounding in today’s complex industrial data management landscape.",
						en: "When Marshall McLuhan said in 1964 that “the medium is the message”, he was primarily speaking about the mediums of print, radio and television. As our industry grows in volume, variety and velocity, this statement remains an important touchpoint for examining our goals and how we create and investigate the content and structures that confront us today. Importantly, the industrial world today functions in what we observe to be a mullti-model ecosystem, with significant needs for harmonization and analytics. What we have learned is that in order to both understand and derive actionable insight from this dynamic world requires the adoption of multi-model techniques and platforms. In this presentation, this evolution and an approach to implementation is outlined and described as an extension of McLuhan’s statement, providing crucial grounding in today’s complex industrial data management landscape.",
					},
					speakers: ["blau-frank"]
				},
				{ // OK-LIVE - KEYNOTE-2
					ident: "keynote-berecki",
					duration: 30,
					language: "hr",
					keynote: true,
					title: {
						hr: "Evolucija ljudskog uma: od kiselog kupusa do GMOzga i dalje",
						en: "Evolucija ljudskog uma: od kiselog kupusa do GMOzga i dalje",
					},
					description: {
						hr: "Kako nas je evolucija dovela do ovladavanja znanošću i sposobnošću izrade inteligentnih računala... i kako će interakcija s računalima i biotehnološkim znanostima evolucijski pogurati naš mozak dalje, u smjeru (možda) neizvjesne, ali (sigurno) uzbudljive budućnosti.",
						en: "Kako nas je evolucija dovela do ovladavanja znanošću i sposobnošću izrade inteligentnih računala... i kako će interakcija s računalima i biotehnološkim znanostima evolucijski pogurati naš mozak dalje, u smjeru (možda) neizvjesne, ali (sigurno) uzbudljive budućnosti.",
					},
					speakers: ["berecki-igor"]
				},
				{ // OK-LIVE+++
					ident: "phoenix-live-view",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "heavy",
					title: {
						hr: "Phoenix Live View - SPA u Elixiru s minimalno Javascripta",
						en: "Phoenix Live View - SPA u Elixiru s minimalno Javascripta",
						// en: "Phoenix Live View - SPA in Elixir with minimal Javascript",
					},
					description: {
						hr: 'Phoenix Live View je jedan od prvih "HTML kroz websockete" frameworka. Na poprilčno moćan način omogućava razvoj kompliciranih interakcija u web aplikaciji s minimalnom potrebom za JavaScriptom, a da pritom zaobilazi jedan čitav sloj u tipičnoj web aplikaciji - JSON/REST.',
						en: 'Phoenix Live View je jedan od prvih "HTML kroz websockete" frameworka. Na poprilčno moćan način omogućava razvoj kompliciranih interakcija u web aplikaciji s minimalnom potrebom za JavaScriptom, a da pritom zaobilazi jedan čitav sloj u tipičnoj web aplikaciji - JSON/REST.',
						// en: 'Phoenix Live View is one of the first "HTML through websockets" frameworks. In a rather powerful way, it enables the development of complicated interactions in a web application with a minimal need for JavaScript, while bypassing one entire layer in a typical web application - JSON/REST.',
					},
					speakers: ["begedin-nikola"]
				},
				{ // OK-LIVE+++
					ident: "fun-with-symphony",
					duration: 30,
					language: "hr",
					level: "novice",
					code: "light",
					title: {
						// hr: "Zabava s naredbama Symfony konzole",
						hr: "Fun with Symfony console commands",
						en: "Fun with Symfony console commands",
					},
					description: {
						// hr: "Symfony konzolna komponenta je industrijski standard za PHP konzolne naredbe. U ovom govoru govorit ću o Symfony konzolnoj komponenti, kako je definirati, kako je koristiti, zašto je korisna. Također ćete dobiti uvid kako je proširiti i najbolje iskoristiti. Pokazat ću kako koristiti auto-complete, kako upravljati unosima, modificirati i stilizirati izlaz i dobiti/pružiti najkorisniji izlaz na različitim razinama detalja. To je stvarno moćan alat i trebali bismo uzeti većinu onoga što nam pruža. Objasnit ću vam kako to učiniti.",
						hr: "Symfony console component is industry standard for PHP console commands. In this talk I'll speak about Symfony console component, how to define it, how to use it, why it's useful. Also you will get insight how to extend it and get most of it. I will demonstrate how to use autocomplete, how to manage inputs, modify and style output and get/provide most useful output on different verbosity levels. It's really powerful tool and we should get most of what it is providing. I'll explain you how to do it.",
						en: "Symfony console component is industry standard for PHP console commands. In this talk I'll speak about Symfony console component, how to define it, how to use it, why it's useful. Also you will get insight how to extend it and get most of it. I will demonstrate how to use autocomplete, how to manage inputs, modify and style output and get/provide most useful output on different verbosity levels. It's really powerful tool and we should get most of what it is providing. I'll explain you how to do it.",
					},
					speakers: ["matijanic-borna"]
				},
				{ // OK-LIVE+++ - duraction estimated & locked 
					ident: "programmatic-creation-multimetia-content",
					duration: 45, // DEBUG=60 / original=45
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						// hr: "Programsko stvaranje multimedijskog sadržaja korištenjem generativnih AI usluga",
						hr: "Programmatic Creation of Multimedia Content Using Generative AI Services",
						en: "Programmatic Creation of Multimedia Content Using Generative AI Services",
					},
					description: {
						// hr: 'Svakodnevno se susrećemo s mnoštvom sadržaja, od kojih većina spada u kategoriju "smeća". Za stvaranje kvalitetnog i relevantnog sadržaja koji će privući publiku potrebno je uložiti puno truda, a još više ako se želi postići "wow efekt". Zašto ne potražiti pomoć od web servisa koji koriste generativni Al za stvaranje sadržaja?<br/>Što ako bi oni to mogli učiniti iz njihovih aplikacija umjesto da mi kao korisnici pišemo zahtjev u promptu?<br/>Ovo predavanje ima za cilj pokazati kako se sadržaj može izraditi programski pomoću API-ja tih web usluga!',
						hr: 'Every day, we face a lot of content, most of which falls into the "junk" category. Investing a lot of effort is necessary to create quality and relevant content that will attract the audience, and even more effort if you want to achieve the "wow effect". Why not seek help from web services that use generative Al to create content?<br/>And what if they could do it from their applications instead of us as users writing a request in the prompt?<br/>This lecture aims to show how content can be created programmatically using the API of these web services!',
						en: 'Every day, we face a lot of content, most of which falls into the "junk" category. Investing a lot of effort is necessary to create quality and relevant content that will attract the audience, and even more effort if you want to achieve the "wow effect". Why not seek help from web services that use generative Al to create content?<br/>And what if they could do it from their applications instead of us as users writing a request in the prompt?<br/>This lecture aims to show how content can be created programmatically using the API of these web services!',
					},
					speakers: ["miodragovic-jelena", "bronzin-tomislav"]
				},
				{ // OK-LIVE+++
					ident: "what-after-spa",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						hr: "Što nakon SPA? Moderni razvoj klijentskih web aplikacija",
						en: "Što nakon SPA? Moderni razvoj klijentskih web aplikacija",
						// en: "What after SPA? Modern development of client web applications",
					},
					description: {
						hr: "Sigurno ste već radili jednostranične / single-page aplikacije (SPA)  te zamjetili da ne morate nužno nanovo učiti nove koncepte. Većina dobrih praksi se uvelike ne mijenja i, kao razvojni inženjer, možete koristiti svoje postojeće znanje - samo usmjereno na pravi način. Nadalje, već neko vrijeme, razvoj modernih web aplikacija na klijentu uključuje i mnoga poboljšanja performansi, renderiranja te uporabu sve više serverskog koda. Provest ću vas kroz općepoznate principe koje možete primjeniti za razvoj vaše omiljene SPA te što budućnost donosi kroz meta i full-stack web frameworke.",
						en: "Sigurno ste već radili jednostranične / single-page aplikacije (SPA)  te zamjetili da ne morate nužno nanovo učiti nove koncepte. Većina dobrih praksi se uvelike ne mijenja i, kao razvojni inženjer, možete koristiti svoje postojeće znanje - samo usmjereno na pravi način. Nadalje, već neko vrijeme, razvoj modernih web aplikacija na klijentu uključuje i mnoga poboljšanja performansi, renderiranja te uporabu sve više serverskog koda. Provest ću vas kroz općepoznate principe koje možete primjeniti za razvoj vaše omiljene SPA te što budućnost donosi kroz meta i full-stack web frameworke.",
						// en: "You've probably already done single-page applications (SPA) and noticed that you don't necessarily have to learn new concepts all over again. Most good practices don't change much and, as a developer, you can use your existing knowledge - just channeled in the right way. Furthermore, for some time, the development of modern web applications on the client includes many improvements in performance, rendering and the use of more and more server code. I will take you through the well-known principles that you can apply for the development of your favorite SPA and what the future brings through meta and full-stack web frameworks.",
					},
					speakers: ["cosic-ratko"]
				},
				{ // OK-LIVE+++
					ident: "development-cloud-native-apps",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						hr: "Razvoj cloud-native aplikacija uz .NET 8 i .NET Aspire",
						en: "Razvoj cloud-native aplikacija uz .NET 8 i .NET Aspire",
						// en: "Development of cloud-native applications with .NET 8 and .NET Aspire",
					},
					description: {
						hr: "Uz pregršt mogućnosti koji nudi novi .NET 8 za razvojne inženjere, razvoj cloud-native aplikacija postaje jednostavan i kvalitetan uz .NET Aspire. Implementacija distribuiranih aplikacija lokalno nije nikad bila tako laka uz pregled mikroservisa kroz kontejnere, telemetriju, dostupnost i otkrivanje servisa, na jednom mjestu. U ovom predavanju predstavit ću vam kako možete iskoristiti brojne prednosti rada uz .NET 8 i .NET Aspire - novog alata za moderni razvoj cloud-native aplikacija.",
						en: "Uz pregršt mogućnosti koji nudi novi .NET 8 za razvojne inženjere, razvoj cloud-native aplikacija postaje jednostavan i kvalitetan uz .NET Aspire. Implementacija distribuiranih aplikacija lokalno nije nikad bila tako laka uz pregled mikroservisa kroz kontejnere, telemetriju, dostupnost i otkrivanje servisa, na jednom mjestu. U ovom predavanju predstavit ću vam kako možete iskoristiti brojne prednosti rada uz .NET 8 i .NET Aspire - novog alata za moderni razvoj cloud-native aplikacija.",
						// en: "With a handful of possibilities offered by the new .NET 8 for development engineers, the development of cloud-native applications becomes simple and high-quality with .NET Aspire. Deploying distributed applications locally has never been easier with a view of microservices through containers, telemetry, availability and service discovery, all in one place. In this lecture, I will present you how you can take advantage of the numerous advantages of working with .NET 8 and .NET Aspire - a new tool for modern cloud-native application development.",
					},
					speakers: ["cosic-ratko"]
				},
				{ // OK-LIVE+++ - duration updated with +5 minutes
					ident: "refactoring-art-craft",
					duration: 30, // speaker wrote 25 minutes
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						// hr: "Refactoring: umjetnost poboljšanja koda",
						hr: "Refactoring: The art and craft of code improvement",
						en: "Refactoring: The art and craft of code improvement",
					},
					description: {
						// hr: "Prerađivanje koda nešto je što svi vole mrziti i o čemu razmišljaju kao o zadatku ili kazni. Ovo treba tretirati kao preuređenje koda za koji ne trebate angažirati Mirjanu Mikulec :)\r\n\r\nPočet ću s onim što je to, zašto to radimo i nastaviti s filozofijom i teorijom koja stoji iza toga. Nakon što svi budu zaspali ili potpuno budni, nastavit ću s praktičnim tehnikama i osobnim primjerima.",
						hr: "Code refactoring is something that everybody loves to hate and think of it as a chore or a punishment. While it should be treated as code makeover for which you don't need to hire Mirjana Mikulec :)\r\n\r\nI'll start with what is it, why do we do it and continue with a philosophy and theory behind it. After everybody is either asleep or wide awake I'll continue with practical techniques and personal examples.",
						en: "Code refactoring is something that everybody loves to hate and think of it as a chore or a punishment. While it should be treated as code makeover for which you don't need to hire Mirjana Mikulec :)\r\n\r\nI'll start with what is it, why do we do it and continue with a philosophy and theory behind it. After everybody is either asleep or wide awake I'll continue with practical techniques and personal examples.",
					},
					speakers: ["peharda-luka"],
				},
				{ // OK-LIVE+++
					ident: "tauri-desktop-solutions",
					duration: 45,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						// hr: "Tauri - desktop rješenje za web programera",
						hr: "Tauri - a web developer's desktop solution",
						en: "Tauri - a web developer's desktop solution",
					},
					description: {
						hr: "Jeste li ikada imali potrebu izraditi desktop rješenje, a niste imali vremena učiti novu tehnologiju? U ovom predavanju proći ćemo kroz jedno od novijih rješenja - Tauri. Ovaj framework je izrađen na Rustu te koristi Rust kao mini 'backend' koji ima funkciju mosta između vaše web aplikacije i operacijskog sustava, a za frontend se koristi bilo koji Javascript framework.",
						en: "Jeste li ikada imali potrebu izraditi desktop rješenje, a niste imali vremena učiti novu tehnologiju? U ovom predavanju proći ćemo kroz jedno od novijih rješenja - Tauri. Ovaj framework je izrađen na Rustu te koristi Rust kao mini 'backend' koji ima funkciju mosta između vaše web aplikacije i operacijskog sustava, a za frontend se koristi bilo koji Javascript framework.",
						// en: "Have you ever needed to create a desktop solution and didn't have time to learn new technology? In this lecture, we will go through one of the newer solutions - Tauri. This framework is built on Rust and uses Rust as a mini 'backend' that has the function of a bridge between your web application and the operating system, and any Javascript framework is used for the frontend.",
					},
					speakers: ["vidovic-filip"],
				},
				{ // OK-LIVE+++
					ident: "failing-at-agile",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "none",
					title: {
						// hr: "Ne uspijevate biti agilni?",
						hr: "Are you failing at being agile?",
						en: "Are you failing at being agile?",
					},
					description: {
						// hr: "U proteklih nekoliko godina agilne metode postale su vitalni dio procesa razvoja softvera, no jesu li stvarno primjenjive za sve vrste projekata i veličine timova?\r\n\r\nPrije nekog vremena naša je tvrtka promijenila način pristupa razvoj projekta jer je tim primijetio da standardne SCRUM-ish metode nisu u potpunosti kompatibilne za nas, pa smo razvili vlastitu, modificiranu verziju agilnosti. U ovom govoru pokazat ću koliko je moćan ovaj pristup i kako ga možete koristiti za pronalaženje problema i njihovo konačno rješavanje.",
						hr: "In these past few years, agile methods became a vital part in the software development process, but are they really applicable for all types of projects and team sizes?\r\n\r\nA while ago, our company changed the way we approach project development because the team noticed that standard SCRUM-ish methods aren't fully compatible for us, so we developed our own, modified version of agile. In this talk, I will showcase how powerful this approach is and how you can use it to find problems, and eventually resolve them.",
						en: "In these past few years, agile methods became a vital part in the software development process, but are they really applicable for all types of projects and team sizes?\r\n\r\nA while ago, our company changed the way we approach project development because the team noticed that standard SCRUM-ish methods aren't fully compatible for us, so we developed our own, modified version of agile. In this talk, I will showcase how powerful this approach is and how you can use it to find problems, and eventually resolve them.",
					},
					speakers: ["peric-mazar-antonio"],
				},
				{ // OK-LIVE+++
					ident: "unveiling-wasmcov",
					duration: 45,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						// hr: "Otkrivamo WasmCov: Revolucioniranje testne pokrivenosti u Wasm ekosustavima",
						hr: "Unveiling WasmCov: Revolutionizing Test Coverage Across Wasm Ecosystems",
						en: "Unveiling WasmCov: Revolutionizing Test Coverage Across Wasm Ecosystems",
					},
					description: {
						// hr: "WebAssembly (Wasm) je doživio široku primjenu ali i dalje postoji značajan nedostatak podrške za sveobuhvatna rješenja testne pokrivenosti kao što je LLVM. U području blockchaina, gdje ranjivosti koda mogu imati ozbiljne posljedice, oslanjanje na automatizirano testiranje postaje najvažnije. Ova prezentacija istražuje ograničenja trenutnih testnih paketa za Wasm i predstavlja inovativno rješenje - WasmCov. Razvijen od strane Noah Jelicha i Bartosz Barwikowskija iz Hackena, WasmCov je prvijenac na području pokrivenosti Wasm modula, pružajući robustan alat za testiranje i jačanje razvoja pametnih ugovora u blockchain okruženjima.\r\n\r\nPridružite nam se dok otkrivamo WasmCov i istražujemo njegov potencijal za redefiniranje pouzdanosti i sigurnosti pametnih ugovora temeljenih na Wasmu.",
						hr: "WebAssembly (Wasm) has seen widespread adoption, yet a significant challenge persists—lack of support for comprehensive test coverage solutions like LLVM. In the realm of blockchain, where code vulnerabilities can have severe consequences, relying on automated testing becomes paramount. This presentation delves into the limitations of current test coverage suites for Wasm and introduces an innovative solution - WasmCov. Developed by Noah Jelich and Bartosz Barwikowski at Hacken, WasmCov pioneers the field of Wasm module coverage, providing a robust testing tool to fortify smart contract development in blockchain environments.\r\n\r\nJoin us as we unveil WasmCov and explore its potential to redefine the reliability and security of Wasm-based smart contracts.",
						en: "WebAssembly (Wasm) has seen widespread adoption, yet a significant challenge persists—lack of support for comprehensive test coverage solutions like LLVM. In the realm of blockchain, where code vulnerabilities can have severe consequences, relying on automated testing becomes paramount. This presentation delves into the limitations of current test coverage suites for Wasm and introduces an innovative solution - WasmCov. Developed by Noah Jelich and Bartosz Barwikowski at Hacken, WasmCov pioneers the field of Wasm module coverage, providing a robust testing tool to fortify smart contract development in blockchain environments.\r\n\r\nJoin us as we unveil WasmCov and explore its potential to redefine the reliability and security of Wasm-based smart contracts.",
					},
					speakers: ["jelich-noah"],
				},
				{ // OK-LIVE+++
					ident: "generating-sounds-rnbq",
					duration: 45,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						// hr: "Generiranje zvukova na webu korištenjem RNBO",
						hr: "Generating sounds on the web by utilizing RNBO",
						en: "Generating sounds on the web by utilizing RNBO",
					},
					description: {
						// hr: 'Max je vizualni programski jezik za glazbu i koristi se za stvaranje novih instrumenata i zvukova. Ali u najnovijem ažuriranju postoji mogućnost korištenja na webu.\r\n\r\nU ovom predavanju ćemo ukratko proći kroz povijest DAW-a (Digital Audio Workstation) i pregledati Max vizualni programski jezik za glazbu. Zatim ćemo "sastaviti" sustav za korištenje na webu i isprobati ga u stvarnom vremenu!',
						hr: "Max is a visual programming language for music and has been used for creating new instruments and sounds. But in a latest update there's an ability to use it on the web.\r\n\r\nIn this talk we will briefly go through the history of DAW's (Digital Audio Workstation) and go over the Max visual programming language for music. We will then \"compile\" the system for usage on the web and see it in real-time action!",
						en: "Max is a visual programming language for music and has been used for creating new instruments and sounds. But in a latest update there's an ability to use it on the web.\r\n\r\nIn this talk we will briefly go through the history of DAW's (Digital Audio Workstation) and go over the Max visual programming language for music. We will then \"compile\" the system for usage on the web and see it in real-time action!",
					},
					speakers: ["fusic-duro"],
				},
				{ // OK-LIVE+++
					ident: "scaling-work-queues-oban",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "heavy",
					title: {
						// hr: "Skaliranje niza jobova s Obanom: Iskorištavanje moći Elixira za pouzdanu obradu u pozadini",
						hr: "Scaling Work Queues with Oban: Harnessing Elixir's Power for Reliable Background Processing",
						en: "Scaling Work Queues with Oban: Harnessing Elixir's Power for Reliable Background Processing",
					},
					description: {
						// hr: "Oban, robusna i fleksibilna biblioteka za obradu jobova za Elixir, promijenila je svijetu pozadinske obrade jobova. Izgrađen na temelju moćnih značajki PostgreSQL-a, Oban nudi neusporedivu pouzdanost, skalabilnost i jednostavnost korištenja. U ovom govoru zaronit ćemo duboko u Oban, istražujući njegove temeljne koncepte, najbolje prakse i primjene u stvarnom svijetu. Bilo da ste iskusni Elixir programer ili tek počinjete, ova će vas sesija opremiti znanjem i alatima za učinkovito upravljanje nizom jobova i pozadinskim jobova u vašim Elixir aplikacijama.",
						hr: "Oban, a robust and flexible job processing library for Elixir, has become a game-changer in the world of background job processing. Built on top of PostgreSQL's powerful features, Oban offers unparalleled reliability, scalability, and ease of use. In this talk, we'll dive deep into Oban, exploring its core concepts, best practices, and real-world applications. Whether you're a seasoned Elixir developer or just getting started, this session will equip you with the knowledge and tools to effectively manage work queues and background jobs in your Elixir applications.",
						en: "Oban, a robust and flexible job processing library for Elixir, has become a game-changer in the world of background job processing. Built on top of PostgreSQL's powerful features, Oban offers unparalleled reliability, scalability, and ease of use. In this talk, we'll dive deep into Oban, exploring its core concepts, best practices, and real-world applications. Whether you're a seasoned Elixir developer or just getting started, this session will equip you with the knowledge and tools to effectively manage work queues and background jobs in your Elixir applications.",
					},
					speakers: ["crnkovic-andrei-zvonimir"],
				},
				{ // OK-LIVE+++
					ident: "core-vs-dapper",
					duration: 45,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						// hr: "Bitka Titana: EF Core protiv Dappera",
						hr: "Battle of Titans: EF Core vs Dapper",
						en: "Battle of Titans: EF Core vs Dapper",
					},
					description: {
						hr: "Kroz predavanje uspoređujemo dva najpopularnija ORM-a za .NET ekosustav koji su ujedno i prvi izbor kod većine projekata u toj tehnologiji. Oni nude visoku razinu interakcije s relacijskim bazama podataka ali se razlikuju u performansama, kompleksnosti i fleksibilnosti. Suočit ćemo oba frameworka kroz prizmu lakoće korištenja, performansa, fleksibilnosti, podrške i naprednih funkcija te napraviti zaključak da bi lakše izabrali opciju za sljedeći projekt.",
						en: "Kroz predavanje uspoređujemo dva najpopularnija ORM-a za .NET ekosustav koji su ujedno i prvi izbor kod većine projekata u toj tehnologiji. Oni nude visoku razinu interakcije s relacijskim bazama podataka ali se razlikuju u performansama, kompleksnosti i fleksibilnosti. Suočit ćemo oba frameworka kroz prizmu lakoće korištenja, performansa, fleksibilnosti, podrške i naprednih funkcija te napraviti zaključak da bi lakše izabrali opciju za sljedeći projekt.",
						// en: "Through the lecture, we compare the two most popular ORMs for the .NET ecosystem, which are also the first choice for most projects in that technology. They offer a high level of interaction with relational databases but differ in performance, complexity and flexibility. We will confront both frameworks through the prism of ease of use, performance, flexibility, support and advanced functions and make a conclusion that it would be easier to choose an option for the next project.",
					},
					speakers: ["saric-marko"],
				},
				{ // OK-LIVE+++
					ident: "micro-frontends-nx-angular",
					duration: 45,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						hr: "Micro Frontends with Nx & Angular",
						en: "Micro Frontends with Nx & Angular",
					},
					description: {
						hr: "The session will give an overview of Micro Frontend (MFE) architecture and compare it to traditional app development, highlighting the key differences and benefits. It will show MFE architecture in practice, sharing useful tips and tricks. The use of an Nx monorepo as a great fit for implementing MFE architecture will be discussed, explaining its advantages. Finally, it will advise on appropriate instances to build an MFE architecture, guiding participants on when it's most beneficial to use this approach.",
						en: "The session will give an overview of Micro Frontend (MFE) architecture and compare it to traditional app development, highlighting the key differences and benefits. It will show MFE architecture in practice, sharing useful tips and tricks. The use of an Nx monorepo as a great fit for implementing MFE architecture will be discussed, explaining its advantages. Finally, it will advise on appropriate instances to build an MFE architecture, guiding participants on when it's most beneficial to use this approach."
					},
					speakers: ["voska-filip"],
				},
				{ // OK-LIVE+++
					ident: "leveraging-elasticsearch-net8",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						"hr": "Leveraging Elasticsearch in .NET 8",
						"en": "Leveraging Elasticsearch in .NET 8"
					},
					description: {
						hr: "Understanding of integrating and utilizing Elasticsearch within the .NET 8. Learn the significance of Elasticsearch in handling large-scale data and the benefits of using it with .NET for enhanced search capabilities. The talk will address common challenges and solutions in integrating Elasticsearch with .NET.",
						en: "Understanding of integrating and utilizing Elasticsearch within the .NET 8. Learn the significance of Elasticsearch in handling large-scale data and the benefits of using it with .NET for enhanced search capabilities. The talk will address common challenges and solutions in integrating Elasticsearch with .NET."
					},
					speakers: ["hrncic-marko"]
				},
				{ // OK-LIVE+++
					ident: "flying-actuaries",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "none",
					title: {
						"hr": "The Flying ActuaRies",
						"en": "The Flying ActuaRies"
					},
					description: {
						hr: "Let's face it – R isn't exactly the star of the cloud computing show. The idea seems straightforward: collect some data, process it, and then store the results. However, transforming a project from \"it works on my machine\" to a scalable, reliable cloud-based solution presents a real challenge, especially for those like actuaries who haven't chosen coding as their career path.\r\n\r\nThis tale is about crafting a cloud solution the right way, emphasizing teamwork, exploration, gradual improvement, and how IT professionals can pave the way for actuaries, allowing them to concentrate on their core responsibilities.\r\n\r\nIn our journey, we chose Azure Databricks as our platform. But there's a twist: the actuaries don't directly interact with Databricks. Instead, we've developed a system that's not only distinct but also more empowering than the standard procedures you might find in an average online tutorial.",
						en: "Let's face it – R isn't exactly the star of the cloud computing show. The idea seems straightforward: collect some data, process it, and then store the results. However, transforming a project from \"it works on my machine\" to a scalable, reliable cloud-based solution presents a real challenge, especially for those like actuaries who haven't chosen coding as their career path.\r\n\r\nThis tale is about crafting a cloud solution the right way, emphasizing teamwork, exploration, gradual improvement, and how IT professionals can pave the way for actuaries, allowing them to concentrate on their core responsibilities.\r\n\r\nIn our journey, we chose Azure Databricks as our platform. But there's a twist: the actuaries don't directly interact with Databricks. Instead, we've developed a system that's not only distinct but also more empowering than the standard procedures you might find in an average online tutorial."
					},
					speakers: ["culjak-ivan"]
				},
				{ // OK-LIVE+++
					ident: "real-world-llms",
					duration: 30,
					language: "hr",
					level: "intermediate",
					code: "light",
					title: {
						"hr": "Real World Use Cases for Large Language Models",
						"en": "Real World Use Cases for Large Language Models"
					},
					description: {
						hr: "Practical applications and real-world impact of Large Language Models (LLMs)",
						en: "Practical applications and real-world impact of Large Language Models (LLMs)"
					},
					speakers: ["novak-josip", "bistrovic-jurica"]
				},
				// --- special sessions - this is used to show up in survey, otherwise, it can be used directly in schedule
				// { // PREP - AFTER PARTY
				// 	// visible: false,
				// 	ident: "after-party",
				// 	duration: -1,
				// 	title: {
				// 		hr: "Završna fešta",
				// 		en: "After Party",
				// 	},
				// 	description: {
				// 		hr: "Druženje i networking u opuštenoj atmosteferi uz muziku, hranu i piće.",
				// 		en: "Socializing and networking in a relaxed atmosphere with music, food and drinks."
				// 	},
				// }
			],
			schedule: [
				{ // registration
					duration: 60,
					skipOnSurvey: true,
					language: "hr",
					title: {
						hr: "Registracija",
						en: "Registration",
					},
					description: {
						hr: "Okupljanje i registracija",
						en: "Gathering and registration",
					},
					doNotEvaluate: true,
				},
				TRACK_BREAK(10),
				{ // opening ceremony
					duration: 10,
					skipOnSurvey: true,
					language: "hr",
					title: {
						hr: "Otvaranje konferencije",
						en: "Conference Opening",
					},
					description: {
						hr: "Brza dobrodošlica od strane organizatora i nekih sponzora",
						en: "Quick welcome note from one of the organizers and few sponsors",
					},
					moderators: [],
					doNotEvaluate: true,
				},
				TRACK_BREAK(10),
				{ // keynote #1
					session: "keynote-blau"
				},
				TRACK_BREAK(),
				[
					{
						session: "phoenix-live-view", // 30 min
					},
					{
						session: "fun-with-symphony" // 30 min
					},
				],
				TRACK_BREAK(),
				[
					{
						session: "programmatic-creation-multimetia-content" // 45 min
					},
					{
						session: "generating-sounds-rnbq" // 45 min
					},
				],
				TRACK_BREAK(),
				[
					{
						session: "development-cloud-native-apps" // 30 min
					},
					{
						session: "refactoring-art-craft" // 30 min
					},
				],
				TRACK_BREAK(),
				[
					{
						session: "unveiling-wasmcov" // 45 min
					},
					{
						session: "tauri-desktop-solutions" // 45 min
					},
				],
				LUNCH_BREAK(75),
				[
					{
						session: "flying-actuaries" // 30 min
					},
					{
						session: "failing-at-agile" // 30 min
					},
				],
				TRACK_BREAK(),
				[
					{
						session: "scaling-work-queues-oban" // 30 min
					},
					{
						session: "real-world-llms" // 30 min
					},
				],
				TRACK_BREAK(),
				[
					{
						session: "micro-frontends-nx-angular" // 45 min
					},
					{
						session: "core-vs-dapper" // 45 min
					},
				],
				TRACK_BREAK(),
				[
					{
						session: "what-after-spa" // 30 min
					},
					{
						session: "leveraging-elasticsearch-net8" // 30 min
					},
				],
				TRACK_BREAK(),
				{ // keynote #2
					session: "keynote-berecki"
				},
				TRACK_BREAK(),
				{ // AFTER PARTY
					ident: "after-party",
					duration: -1,
					title: {
						hr: "Završna fešta",
						en: "After Party",
					},
					description: {
						hr: "Druženje i networking u opuštenoj atmosferi uz muziku, hranu i piće.",
						en: "Socializing and networking in a relaxed atmosphere with music, food and drinks."
					},
				}
			],
			faq: {
				hr: [
					{
						title: "Što je Weblica?",
						short: "",
						full: "Weblica je konferencija posvećena web tehnologijama i IT sektoru koja okuplja različite stručnjake i entuzijaste iz cijele regije.",
					},
					{
						title: "Gdje i kada će se održati Weblica {{currentYear}}?",
						short: "",
						full: [
							"Weblica {{currentYear}} održat će se {{eventDate}} s početkom u {{eventTime}} sati.<br/>",
							"Adresa: {{venueNameAndAddress}}<br/><br/>",
							"Pronađi lokaciju <a href='{{mapUrl}}' target='_blank'>na ovoj karti</a>.",
						],
					},
					{
						title: "Kako se prijaviti za sudjelovanje kao predavač na Weblici i koji je rok za prijavu?",
						short: "",
						full: [
							`Prijave za predavače završavaju {{lectureRegistration.to}} u ponoć, a prijaviti se možete putem <a href='{{sessionsUrl}}' target='_blank'>Sessionize platforme</a>`,
						],
					},
					{
						title: "Koji su glavni sadržaji konferencije?",
						short: "",
						full: "Konferencija obuhvaća  razna predavanja, radionice i panel diskusije o najnovijim trendovima i temama u web tehnologijama.",
					},
					{
						title: "Koja je ciljna publika Weblice?",
						short: "",
						full: "Weblica okuplja stručnjake iz IT sektora, developere, programere, dizajnere, poduzetnike te sve koji su strastveni prema web tehnologijama.",
					},
					{
						title: "Kako mogu postati sponzor Weblice?",
						short: "",
						full: "Ako ste zainteresirani za sponzorstvo, pošaljite nam upit <a href='/{{linkLang}}/sponsors'>korištenjem ove forme.</a>",
					},
					{
						title: "Je li sudjelovanje na Weblici besplatno?",
						short: "",
						full: "Cijene sudjelovanja mogu se razlikovati ovisno o vrsti ulaznice i što ona omogućuje. Više informacija možete saznati na <a href='/{{linkLang}}/{{event}}/#tickets'>ovdje</a>.",
					},
					{
						title: "Trebam li imati tehničko predznanje za sudjelovanje na konferenciji?",
						short: "",
						full: "Weblica je namijenjena različitim razinama znanja, tako da i početnici i oni iskusniji mogu pronaći relevantne sadržaje.",
					},
					{
						title: "Kako mogu volontirati na konferenciji?",
						short: "",
						full: "Volonteri su i više nego dobro došli. Ako si zainteresiran(a) za sudjelovanje kao volonter, <a href='/{{linkLang}}/volunteer'>popuni ovu formu</a>.",
					},
					{
						title: "Hoće li negdje biti omogućeno parkirati automobil?",
						short: "",
						full: "Da, omogućen je besplatan parking.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
				en: [
					{
						title: "What is Weblica?",
						short: "",
						full: "Weblica is a conference dedicated to web technologies and the IT sector that brings together various experts and enthusiasts from the entire region.",
					},
					{
						title: "Where and when will Weblica {{currentYear}} be held?",
						short: "",
						full: [
							"Weblica {{currentYear}} will be held on {{eventDate}}, starting at {{eventTime}}<br/>",
							"Address: {{venueNameAndAddress}}<br/><br/>",
							"Find the location <a href='{{mapUrl}}' target='_blank'>on this map</a>.",
						],
					},
					{
						title: "How to apply for participation as a speaker on Weblica and what is the application deadline?",
						short: "",
						full: `Applications for speakers end on {{lectureRegistration.to}} at midnigth, and you can register via <a href='{{sessionsUrl}}' target='_blank'>Sessionize platform</a>`,
					},
					{
						title: "What are the main contents of the conference?",
						short: "",
						full: "The conference includes various lectures, workshops and panel discussions on the latest trends and topics in web technologies.",
					},
					{
						title: "What is the target audience of Weblica?",
						short: "",
						full: "Weblica brings together experts from the IT sector, developers, programmers, designers, entrepreneurs and everyone who is passionate about web technologies.",
					},
					{
						title: "How can I become a Weblica sponsor?",
						short: "",
						full: "If you are interested in sponsorship, please send us an inquiry <a href='/{{linkLang}}/sponsors'>using this form.</a>",
					},
					{
						title: "Is participation on Weblica free of charge?",
						short: "",
						full: "Participation prices may vary depending on the type of ticket and what it enables. You can find out more information at <a href='/{{linkLang}}/{{event}}/#tickets'>here</a>.",
					},
					{
						title: "Do I need to have technical background to participate in the conference?",
						short: "",
						full: "The website is intended for different levels of knowledge, so that both beginners and more experienced people can find relevant content.",
					},
					{
						title: "How can I volunteer at the conference?",
						short: "",
						full: "Volunteers are more than welcome. If you are interested in participating, please <a href='/{{linkLang}}/volunteer'>use this form</a>.",
					},
					{
						title: "Will it be possible to park a car somewhere?",
						short: "",
						full: "Yes, free parking is available.",
					},
					// {
					// 	title: "x",
					// 	short: "",
					// 	full: ""
					// },
				],
			},
			news: {
				hr: [
					{
						title: "Weblica se vraća u proljeće 2024.",
						when: "2023-11-28",
						short: [
							"<p>Nakon poduže i neplanirane pauze uzrokovane izazovima pandemije COVID-19, Weblica s velikim veseljem najavljuje svoj povratak.</p>",
						],
						// shortImage: {
						// 	file: "weblica-8398-small.jpg",
						// 	alt: "weblica-8398",
						// },
						fullBlocks: [
							{
								width: "half",
								text: [
									"<p>Nadolazeća, 6. konferencija o web tehnologijama, održat će se <b>{{eventDate}}</b>, u srcu Međimurja - Čakovcu.</p>",
									"<p>Tijekom proteklih godina, Weblica je okupila više od 750 tehnoloških entuzijasta i predstavila preko 70 istaknutih predavača, ugostivši tako developere, menadžere, dizajnere, studente i sve one koji dijele strast prema svijetu web tehnologija.</p>",
									"<p>Prilagođavajući se globalnoj situaciji, organizatori su ostali hladne glave i usmjerili energiju na usavršavanje konferencijskog iskustva, organizaciju i osiguranje što boljeg događaja za sve sudionike.</p>",
									'<p>Tako ove godine, Weblica mijenja kulisu i seli na novu <a href="#venue">lokaciju</a> u <b>Zagrebačkoj ulici 87</b> u <b>Čakovcu</b>. Ovaj novi i prostran prostor, izvan centra grada, pruža dodatne mogućnosti za što interaktivniju atmosferu te nove prilike za sve posjetitelje i predavače.</p>',
									"<p>Weblica je nezaobilazni događaj koji prednjači u poticanju rasta IT sektora u sjeverozapadnoj regiji, pružajući najnovije uvide, alate i prilike za suradnju. Zato budite dio Weblice 2024. i dana ispunjenog razmjenom znanja i prilikama za umrežavanje sa super ekipom iz IT svijeta.</p>",
									'<p>Pozivamo i sve potencijalne predavače da podijele svoja znanja, stručnost i iskustva na konferenciji Weblica te prijave svoja predavanja na <a href="{{sessionsUrl}}" target="_blank">sljedećoj poveznici</a>.</p>',
								],
							},
							{
								width: "half",
								image: {
									file: "weblica-8398.jpg", // "weblica-8273.jpg",
									alt: "weblica-8273",
								},
							},
						],
					},
					{
						title: "Konferencijski doživljaj na dva kata!",
						when: "2024-03-14",
						short: [
							"<p>Weblica 2024 donosi velike promjene i novitete koji će obogatiti vaše iskustvo konferencije.</p>",
						],
						full: [
							"<p>Naime, ovogodišnja konferencija odvijat će se na dva kata - jedan kat posvećen inspirativnim predavanjima, a drugi kat će biti epicentar dodatnog sadržaja kreiranog posebno za IT zajednicu.</p>",
							"<p>Pratite nas i dalje jer uskoro stižu detalji.</p>",
						],
					},
					{
						title: "Ugodan smještaj tijekom Weblice uz poseban popust",
						when: "2024-03-27",
						short: [
							"<p>Tražite li savršeno mjesto za odmor blizu srca događanja Weblice?<br/>Želite li udobnost koja prati moderan i pristupačan smještaj? Imamo sjajnu vijest za sve naše posjetitelje!</p>",
						],
						full: [
							"<p>Za sve koji planiraju boravak u Čakovcu tijekom Weblice konferencije, <a href='https://www.hostel-industrial.com' target='_blank'>Hostel Industrial</a> nudi ekskluzivan popust od 10% na sve rezervacije smještaja.</p>",
							"<p>Kako biste iskoristili ovaj poseban popust, jednostavno se obratite Hostelu Industrial putem e-maila na adresi <a href='mailto:info@hostel-industrial.com?subject=Rezervacija - Weblica2024' target='_blank'>info@hostel-industrial.com</a> s promo kodom “Weblica2024” ili pokažite svoju ulaznicu za Weblicu prilikom rezervacije direktno u hostelu.</p>",
						],
					},
					{
						title: "Hvala svima!",
						when: "2024-05-24",
						short: [
							"<p>S ponosom možemo reći da je Weblica 2024 prošla uspješno, a mnoge pohvale za organizaciju daju nam vjetar u leđa za daljnju organizaciju.</p>",
						],
						full: [
							"<p>Uvijek ima mjesta za napredak te težimo biti još bolji i svima priuštiti događaj za pamćenje, stoga vas pozivamo da ostavite svoje dojmove i mišljenja <a href='/{{linkLang}}/survey?event=weblica'>ovdje</a>.</p>",
							"<p>Od srca zahvaljujemo svim sponzorima, partnerima, posjetiteljima, volonterima i svima koji su pomogli pri realizaciji i uspješnosti konferencije.<br/>Vaša podrška i sudjelovanje učinili su ovaj događaj posebnim i nezaboravnim.<br/>Hvala vam što ste dio naše zajednice!</p>",
						],
					},
				],
				en: [
					{
						title: "Weblica is returning in the spring of 2024!",
						when: "2023-11-28",
						// shortImage: {
						// 	file: "weblica-8398-small.jpg",
						// 	alt: "weblica-8398",
						// },
						short: [
							"<p>After a prolonged and unplanned hiatus caused by the challenges of the COVID-19 pandemic, Weblica is thrilled to announce its comeback.</p>",
						],
						fullBlocks: [
							{
								width: "half",
								text: [
									"<p>The upcoming 6th conference on web technologies is scheduled for <b>{{eventDate}}</b>, at the heart of Međimurje - Čakovec.</p>",
									"<p>Over the years, Weblica has brought together more than 750 technology enthusiasts and featured over 70 prominent speakers, hosting developers, managers, designers, students, and all those who share a passion for the world of web technologies.</p>",
									"<p>Adapting to the global situation, organizers remained composed and directed their energy towards enhancing the conference experience, organizing, and ensuring an even more engaging event for all participants.</p>",
									'<p>Therefore, this year, Weblica changes its backdrop and moves to a new <a href="#venue">location</a> at <b>87 Zagrebačka Street</b> in <b>Čakovec</b>. This fresh and spacious venue, outside the city center, provides exciting opportunities for a more interactive atmosphere and new prospects for all attendees and speakers.</p>',
									"<p>Weblica is an essential event that leads in fostering the growth of the IT sector in the northwest region, providing the latest insights, tools, and collaboration opportunities. So, be part of Weblica 2024 and a day filled with knowledge exchange and networking opportunities with the fantastic IT community.</p>",
									'<p>We also invite potential speakers to share their knowledge, expertise, and experiences at the Weblica conference by submitting their presentations at the <a href="{{sessionsUrl}}" target="_blank">following link</a>.',
								],
							},
							{
								width: "half",
								image: {
									file: "weblica-8398.jpg", // "weblica-8273.jpg",
									alt: "weblica-8273",
								},
							},
						],
					},
					{
						title: "A two-floor conference experience!",
						when: "2024-03-14",
						short: [
							"<p>Weblica 2024 brings big changes and new things that will make your conference experience better. </p>",
						],
						full: [
							"<p>This year, the conference will happen on two floors - one floor for inspiring talks, and the other one will be the center for extra stuff made just for the IT community.</p>",
							"<p>Keep following us because more details are coming soon.</p>",
						],
					},
					{
						title: "Comfortable accommodation during Weblica conference with a special discount",
						when: "2024-03-27",
						short: [
							"<p>Are you looking for the perfect place to rest close to the heart of the Weblica event?<br/>Do you want the comfort that comes with modern and affordable accommodation? We have great news for all our visitors!</p>",
						],
						full: [
							"<p>For everyone planning to stay in Čakovec during the Weblica conference, <a href='https://www.hostel-industrial.com' target='_blank'>Hostel Industrial</a> is offering an exclusive 10% discount on all accommodation bookings.</p>",
							"<p>To take advantage of this special discount, simply contact Hostel Industrial by email at <a href='mailto:info@hostel-industrial.com?subject=Reservation - Weblica2024' target='_blank'>info@hostel-industrial.com</a> with the promo code “Weblica2024” or show your Weblica ticket when booking directly at the hostel.</p>",
						],
					},
					{
						title: "Thank You All!",
						when: "2024-05-24",
						short: [
							"<p>We are proud to say that Weblica 2024 was a success, and many compliments on the organization give us motivation for future events.</p>",
						],
						full: [
							"<p>There is always room for improvement, and we strive to be even better and provide a memorable event for everyone, so we invite you to leave your feedback and opinions <a href='/{{linkLang}}/survey?event=weblica'>here</a>.</p>",
							"<p>We sincerely thank all sponsors, partners, visitors, volunteers, and everyone who helped make the conference successful. <br/>Your support and participation made this event special and unforgettable.<br/>Thank you for being part of our community!</p>",
						],
					},
				],
			},
			tickets: [
				{
					ident: "blind-bird",
					icon: "eye-slash",
					title: {
						hr: "Blind Bird",
						en: "Blind Bird",
					},
					// description: {
					// 	hr: "Za one koji žele doći bez obzira na predavače i teme!",
					// 	en: "For those that want to go without knowing the speakers and schedule!"
					// },
					price: 20,
					listed: true,
					available: true,
					startDate: "2023-11-28",
					endDate: "2023-12-16 23:59:59",
					// access: {
					// 	live: true,
					// 	goodies: true,
					// 	extra_goodies: true,
					// 	lunch: true
					// },
				},
				{
					ident: "early-bird",
					icon: "clock",
					title: {
						hr: "Early Bird",
						en: "Early Bird",
					},
					// description: {
					// 	hr: "",
					// 	en: ""
					// },
					price: 30,
					listed: true,
					available: true,
					startDate: "2023-12-17",
					endDate: "2023-12-31 23:59:59",
					// access: {
					// 	live: true,
					// 	goodies: true,
					// 	extra_goodies: true,
					// 	lunch: true
					// },
				},
				{
					ident: "standard",
					icon: "standard",
					title: {
						hr: "Regular Bird",
						en: "Regular Bird",
					},
					// description: {
					// 	hr: "",
					// 	en: ""
					// },
					price: 40,
					listed: true,
					available: true,
					startDate: "2024-01-01",
					endDate: "2024-03-31 23:59:59",
					// access: {
					// 	live: true,
					// 	goodies: true,
					// 	extra_goodies: false,
					// 	lunch: true
					// },
				},
				{
					ident: "late-bird",
					icon: "ambulance",
					title: {
						hr: "Late Bird",
						en: "Late Bird",
					},
					// description: {
					// 	hr: "",
					// 	en: ""
					// },
					price: 50,
					listed: true,
					available: true,
					startDate: "2024-04-01",
					endDate: "2024-05-10 23:59:59",
					// access: {
					// 	live: true,
					// 	goodies: true,
					// 	extra_goodies: false,
					// 	lunch: true
					// },
				}
			],
			testimonials: [
				// { // template
				// 	given: null,
				// 	image: null,
				// 	speaker: true,
				// 	name: null,
				// 	description: {
				// 		hr: null,
				// 		en: null,
				// 	},
				// 	// company: {
				// 	// 	function: {
				// 	// 		hr: null,
				// 	// 		en: null,
				// 	// 	},
				// 	// 	name: {
				// 	// 		hr: null,
				// 	// 		en: null
				// 	// 	},
				// 	// 	logo: null,
				// 	// },
				// 	text: {
				// 		hr: [
				// 		],
				// 		en: [
				// 		]
				// 	}
				// },
				{
					speaker: true,
					name: "Tomislav",
					description: {
						hr: "dizajner i bivši predavač",
						en: "designer and former speaker",
					},
					text: {
						hr: [
							"<p>Weblica je jedno predivno iskustvo jer su prisutni ljudi poput vas, ljudi koji rade isti posao i koji su uspjeli u karijeri koju svi dijelimo. Može se jako puno naučiti iiz predavanja, ali i direktne komunikacije s predavačima jer to nisu neki tamo eterični ljudi iz cijelog svijeta - to su ljudi iz naše okoline koji znaju svoj posao. Mislim da je Weblica super prilika za naučiti nešto novo i napredovati u svojoj karijeri.</p>",
							"<p>Ekipa koja organizira Weblicu, koja stoji iza nje, je zakon. Atmosfera je fantastična i vidi se da ljudi rade sa strašću. Preporučam konferenciju svakome, neće faliti ni dobre zabave, ni hrane, a ni pića.</p>",
						],
						en: [
							"<p>Weblica is one marvelous experience because it is attended by people like you, people who do the same job and who have succeeded in the career we all share. There's so much to learn not only from the lectures but also from direct communication with the speakers because they aren't just some ethereal people from around the world - they are people from our environment who know their job. I think Weblica is a great opportunity to learn something new and advance in your career.</p>",
							"<p>The team organizing Weblica, who stands behind it, is awesome. The atmosphere is fantastic and you can see that people work with passion. I recommend the conference to everyone, there will be no shortage of good fun, food, or drinks.</p>",
						],
					},
				},
				{
					name: "Ivan",
					description: {
						hr: "developer i posjetitelj",
						en: "developer and attendee",
					},
					text: {
						hr: [
							"<p>Na Weblici sam naučio puno novih i korisnih stvari koje koristim svakoga dana, a osim predavanja - ekipa i hrana su super. </p>",
						],
						en: [
							"<p>At Weblica, I learned many new and useful things that I use every day, and besides the lectures - the team and the food are great.</p>",
						],
					},
				},
				{
					speaker: true,
					name: "Marko",
					description: {
						hr: "developer i bivši predavač",
						en: "developer and former speaker",
					},
					text: {
						hr: [
							"<p>Weblica je sinonim za vrhunske predavače,najnovije trendove u IT-u, pregršt zabave i druženje s kolegama. Zato obavezno stavite Weblicu u vaš kalendar i vidimo se u svibnju u Čakovcu.</p>",
						],
						en: [
							"<p>Weblica is synonymous with top-notch speakers, the latest trends in IT, loads of fun, and networking with colleagues. That's why you should definitely put Weblica in your calendar and see you in May in Čakovec.</p>",
						],
					},
				},
				{
					name: "Davor",
					description: {
						hr: "developer i posjetitelj",
						en: "developer and attendee",
					},
					text: {
						hr: [
							"<p>Na Weblicu dolazim od njenog drugog izdanja, i od tad sam stalni član i posjetitelj ovog eventa. Po mojem, ovo je najbolji event u ovoj regiji, što se tiče programske i dizajnerske industrije. Vidimo se na druženju uz pive i ostalo.</p>",
						],
						en: [
							"<p>I have been coming to Weblica since its second edition. In my opinion, this is the best event in this region regarding the programming and design industry. Hope to see you at the gathering with beers and the rest.</p>",
						],
					},
				},
				{
					name: "Viktor",
					description: {
						hr: "developer i posjetitelj",
						en: "developer and attendee",
					},
					text: {
						hr: [
							"<p>Na Weblicu se vraćam svake godine. Sviđa mi se networking, druženje s ljudima, super je ekipa i super su predavanja. Bilo bi mi drago da ima više tema vezanih uz Java programiranje.</p>",
						],
						en: [
							"<p>I come to Weblica every year. I like networking and socializing with people, the team is great and so are the lectures. I would be glad if there were more topics related to Java programming.</p>",
						],
					},
				},
			],
		},
		hacklica: {
			// startDateTime: "2024-05-03 08:00:00",
			// endDateTime: "2024-05-04 08:00:00",
			specialDates: {
				demos: "2024-05-08 09:00:00",
				winningCeremony: "2024-05-14 18:00",
			},
			prizeAmounts: [5000, 3000, 1500],
			menuItems: {
				about: {
					menu: "About",
					url: "/hacklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/hacklica#news",
					visible: false,
				},
				topics: {
					menu: "Topics",
					url: "/hacklica#topics",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/hacklica#venue",
					visible: false,
				},
				faq: {
					menu: "FAQ",
					url: "/hacklica#faq",
					visible: false,
				},
				sponsors: {
					menu: "Sponsors",
					url: "/hacklica#sponsors",
					visible: false,
				},
				terms: {
					menu: "Terms",
					url: "/hacklica/terms",
					special: true,
					visible: false,
				},
				policy: {
					menu: "Policy",
					url: "/hacklica/policy",
					special: true,
					visible: false,
				},
			},
			buttons: {
				register: {
					title: "Register your team",
					url: "/hacklica/register",
					hollow: true,
					dateLimit: "teamRegistration",
					visible: false,
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					introImage: {
						file: "hacklica-2019-2.jpg",
						alt: "Hacklica 2019",
					},
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "hacklica-2019-3.jpg",
								alt: "Hacklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
					],
				},
				news: {
					visible: true,
				},
				topics: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			__venue: {
				name: {
					hr: "Graditeljska škola",
					en: "School of Architecture",
				},
				nameAlt: {
					hr: "Dvorana Graditeljske škole",
					en: "Hall of the School of Architecture",
				},
				street: "Športska ulica 1",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38921, 16.42269],
					zoom: 19,
				},
				mapUrl:
					"https://www.google.com/maps/place/Graditeljska+%C5%A1kola+%C4%8Cakovec/@46.3888122,16.4220393,15z/data=!4m5!3m4!1s0x0:0x129b433371a3c66f!8m2!3d46.3888122!4d16.4220399",
				mapImage: "gsc-dvorana-map.png",
				// openMapUrl: "https://www.openstreetmap.org/way/104277217",
				images: ["gsc-dvorana-1.jpeg", "gsc-dvorana-2.jpeg"],
			},
			__faq: {
				hr: [
					{
						title: "HR-HH-faq 1",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 2",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 3",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 5",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 6",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 7",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 8",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-What is the smallest or the largest team size?",
						short:
							"Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
						full: "Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
					},
					{
						title: "Can we base our work on preexisting work of ours?",
						short: "Short answer would be-no! But ...",
						full: "If your team has some utilities or smaller libraries that can aid you, yes, you can use that. But beware! We will check the code (it is part of judging process) and we will disqualify full teams if we notice that code volume is not consistent with what is possible in 24 hour window. You will be able to speak up of course if such event occurs, but we are all seniors here and can not be fooled so easily!",
					},
					{
						title: "faq 3",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__topics: {
				hr: [
					{
						title: "HR topic 1",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 2",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HR topic 3",
						short:
							"HR Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
				en: [
					{
						title: "EN topic 1",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 2",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "EN topic 3",
						short:
							"EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
				],
			},
		},
		worklica: {
			tracks: ["track1", "track2"],
			externalLinks: EXTERNAL_LINKS,
			startDateTime: null,
			endDateTime: null,
			menuItems: {
				about: {
					menu: "About",
					url: "/worklica#about",
					visible: false,
				},
				news: {
					menu: "News",
					url: "/worklica#news",
					visible: false,
				},
				speakers: {
					menu: "Speakers",
					url: "/worklica#speakers",
					visible: false,
				},
				schedule: {
					menu: "Schedule",
					url: "/worklica#schedule",
					visible: false,
				},
				tickets: {
					menu: "Tickets",
					url: "/worklica#tickets",
					visible: false,
				},
				venue: {
					menu: "Venue",
					url: "/worklica#venue",
					visible: false,
				},
				faq: {
					menu: "FAQ",
					url: "/worklica#faq",
					visible: false,
				},
				sponsors: {
					menu: "Sponsors",
					url: "/worklica#sponsors",
					visible: false,
				},
			},
			buttons: {
				tickets: {
					title: "Get Tickets",
					url: "/worklica#tickets",
					hollow: false,
					external: false,
					visible: false,
					dateLimit: "ticketSales",
				},
				register: {
					title: "Register a workshop",
					url: EXTERNAL_LINKS.sessions,
					hollow: true,
					external: true,
					visible: false,
					dateLimit: "workshopRegistration",
				},
			},
			forcedButtons: {
				sponsor: {
					title: "Become a Sponsor",
					url: "/sponsors",
					hollow: true,
					external: false,
					visible: false,
					dateLimit: "sponsorRegistration",
				},
			},
			sections: {
				hero: {
					visible: true,
					introImage: {
						file: "worklica-2019-1.jpg",
						alt: "Worklica 2019",
					},
					blocks: [],
				},
				about: {
					visible: true,
					blocks: [
						{
							width: "half", // full || half
							image: {
								file: "worklica-2019-4.jpg",
								alt: "Worklica 2019",
							},
						},
						{
							width: "half",
							text: "txt_aaa",
						},
					],
				},
				news: {
					visible: true,
				},
				speakers: {
					visible: true,
				},
				schedule: {
					visible: true,
				},
				venue: {
					visible: true,
				},
				tickets: {
					visible: true,
				},
				faq: {
					visible: true,
				},
				sponsors: {
					visible: true,
				},
				newsletter: {
					visible: true,
				},
				testimonials: {
					visible: false,
				},
				historyGallery: {
					visible: true,
				},
			},
			__venue: {
				name: {
					hr: "MTC",
					en: "MTC",
				},
				nameAlt: {
					hr: "Multitematski Centar",
					en: "Multi Themed Center",
				},
				street: "Športska ulica 6",
				postalCode: "40000",
				city: "Čakovec",
				country: "Croatia",
				countryShort: "HR",
				leaflet: {
					location: [46.38803, 16.41765],
					zoom: 19,
				},
				mapUrl:
					"https://www.google.com/maps/place/MTC+-+Multitematski+Centar/@46.3877824,16.4176536,15z/data=!4m5!3m4!1s0x0:0x43276d3aee412cfc!8m2!3d46.3877735!4d16.4176531",
				mapImage: "mtc-map.png",
				// openMapUrl: "https://www.openstreetmap.org/way/104289114",
				images: ["mtc-1.jpeg", "mtc-2.jpeg"],
			},
			__tickets: [
				{
					ident: "worklica",
					icon: "worklica",
					title: {
						hr: "Worklica",
						en: "Worklica",
					},
					description: {
						hr: "Dođite na radionice i učite radeći na primjerima!",
						en: "Attend the workshops and learn hands-on!",
					},
					access: {
						worklica: true,
						goodies: true,
						lunch: true,
					},
					price: 75,
					listed: true,
					available: true,
					startDate: null,
					endDate: null,
				},
			],
			__speakers: {
				"saric-marko": {
					image: "saric-marko.jpeg",
					name: "Marko",
					surname: "Šarić",
					company: "GlobalLogic Croatia",
					position: "Lead Software Engineer",
					bio: {
						hr: "HR-Marko se bavi razvojem aplikacija, DevOps procesima te je bloger i predavač na različitim community događanjima. Primarno radi rješenja na Microsoft Stacku za Web, mobilne i Azure aplikacije.<br/>Kroz karijeru radio je na različitim projektima za domaće i inozemne klijente, te održao predavanja na nekoliko domaćih konferencija. Nositelj je nekoliko Microsoftovih certifikata na području Web Application Developmenta-a, Cloud Platform and Application Lifecycle Management-a.<br/>Radio je u različitim ulogama u projektnim timovima, od developera do team leadera i DevOps konzultanta pomažući organizacijama u kreiranju DevOps kulture i implementaciji Application Lifecycle Management procesa.<br/>Veliki je ljubitelj Apple eko-sustava, te obožava isprobavati različita Microsoftova rješenja na macOS-u. Kada je udaljen od računala bavi se brdskim biciklom ili pak rasteže prste na gitari.",
						en: "EN-Marko se bavi razvojem aplikacija, DevOps procesima te je bloger i predavač na različitim community događanjima. Primarno radi rješenja na Microsoft Stacku za Web, mobilne i Azure aplikacije.<br/>Kroz karijeru radio je na različitim projektima za domaće i inozemne klijente, te održao predavanja na nekoliko domaćih konferencija. Nositelj je nekoliko Microsoftovih certifikata na području Web Application Developmenta-a, Cloud Platform and Application Lifecycle Management-a.<br/>Radio je u različitim ulogama u projektnim timovima, od developera do team leadera i DevOps konzultanta pomažući organizacijama u kreiranju DevOps kulture i implementaciji Application Lifecycle Management procesa.<br/>Veliki je ljubitelj Apple eko-sustava, te obožava isprobavati različita Microsoftova rješenja na macOS-u. Kada je udaljen od računala bavi se brdskim biciklom ili pak rasteže prste na gitari.",
					},
					social: {
						linkedIn: "aaa",
						twitter: "bbb",
						github: "ccc",
					},
				},
			},
			____schedule: [
				{
					duration: 60,
					language: "hr",
					title: {
						hr: "Registracija",
						en: "Registration",
					},
					description: {
						hr: "HR-Register at one of our desks, get your badge & goodies bag and then-prepare for the rumble!",
						en: "EN-Register at one of our desks, get your badge & goodies bag and then-prepare for the rumble!",
					},
				},
				[
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "AAA-1/3",
							en: "AAA-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "BBB-1/3",
							en: "BBB-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 15,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "AAA-2/3",
							en: "AAA-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "BBB-2/3",
							en: "BBB-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 15,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "AAA-3/3",
							en: "AAA-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "BBB-3/3",
							en: "BBB-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 60,
					break: true,
					lunch: true,
					title: {
						hr: "Ručak",
						en: "Lunch",
					},
					// description: {
					// 	hr: "Njam njam njam!",
					// 	en: "Nom nom nom!"
					// }
				},
				[
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "CCC-1/3",
							en: "CCC-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "DDD-1/3",
							en: "DDD-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 15,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "CCC-2/3",
							en: "CCC-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "DDD-2/3",
							en: "DDD-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 15,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "CCC-3/3",
							en: "CCC-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 75,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "DDD-3/3",
							en: "DDD-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
			],
			__schedule: [
				{
					duration: 60,
					language: "hr",
					title: {
						hr: "Registracija",
						en: "Registration",
					},
					description: {
						hr: "HR-Register at one of our desks, get your badge & goodies bag and then-prepare for the rumble!",
						en: "EN-Register at one of our desks, get your badge & goodies bag and then-prepare for the rumble!",
					},
				},
				{
					duration: 10,
					language: "hr",
					title: {
						hr: "Otvaranje konferencije",
						en: "Conference Opening",
					},
					description: {
						hr: "HR-As per custom, hosts need to do a proper welcome-so, sit down & enjoy the ride!",
						en: "EN-As per custom, hosts need to do a proper welcome-so, sit down & enjoy the ride!",
					},
					moderators: [],
				},
				{
					duration: 35,
					language: "hr",
					title: {
						hr: "Uvod",
						en: "Keynote",
					},
					description: {
						hr: "HR-Bla bla bla-the ussual. But, this one could be interesting. Really. Trust us.",
						en: "EN-Bla bla bla-the ussual. But, this one could be interesting. Really. Trust us.",
					},
					speakers: [],
					moderators: [],
				},
				{
					duration: 15,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "AAA-1/3",
							en: "AAA-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "BBB-1/3",
							en: "BBB-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 10,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "AAA-2/3",
							en: "AAA-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "BBB-2/3",
							en: "BBB-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 10,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "AAA-3/3",
							en: "AAA-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "BBB-3/3",
							en: "BBB-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 65,
					break: true,
					lunch: true,
					title: {
						hr: "Ručak",
						en: "Lunch",
					},
					// description: {
					// 	hr: "Njam njam njam!",
					// 	en: "Nom nom nom!"
					// }
				},
				[
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "CCC-1/3",
							en: "CCC-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "DDD-1/3",
							en: "DDD-1/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 10,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "CCC-2/3",
							en: "CCC-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "DDD-2/3",
							en: "DDD-2/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 10,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				[
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "CCC-3/3",
							en: "CCC-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
					{
						duration: 60,
						language: "",
						level: "",
						code: "",
						tags: [],
						title: {
							hr: "DDD-3/3",
							en: "DDD-3/3",
						},
						description: {
							hr: "",
							en: "",
						},
						speakers: [],
					},
				],
				{
					duration: 15,
					break: true,
					title: {
						hr: "Pauza",
						en: "Break",
					},
				},
				{
					duration: 15,
					title: {
						hr: "Proglašenje pobjednika Hacklice",
						en: "Hacklica Awards Ceremony",
					},
					description: {
						hr: "Bla bla bla",
						en: "Bla bla bla",
					},
					moderators: ["Davor Tarandek", "Nikica Tarandek", "Martina Šafarić"],
				},
				{
					duration: 330,
					title: {
						hr: "Fešta za kraj",
						en: "After Party",
					},
					description: {
						hr: "Nakon rada, ide zabava",
						en: "Let's party!",
					},
				},
			],
			__faq: {
				hr: [
					{
						title: "HR-HH-faq 1",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 2",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 3",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 5",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 6",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 7",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 8",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-What is the smallest or the largest team size?",
						short:
							"Minimum is 2 members (as you probably expected) and the largest team can have up to 6 members. Everything in between is fine by us.",
					},
					{
						title: "Can we base our work on preexisting work of ours?",
						short: "Short answer would be-no! But ...",
						full: "If your team has some utilities or smaller libraries that can aid you, yes, you can use that. But beware! We will check the code (it is part of judging process) and we will disqualify full teams if we notice that code volume is not consistent with what is possible in 24 hour window. You will be able to speak up of course if such event occurs, but we are all seniors here and can not be fooled so easily!",
					},
					{
						title: "faq 3",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "faq 4",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
			__news: {
				hr: [
					{
						title: "HR-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
				en: [
					{
						title: "EN-HH-here we go again",
						when: "2021-09-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
					{
						title: "HH-here we go again #2",
						when: "2021-09-03 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "",
					},
					{
						title: "HH-full steam ahead",
						when: "2021-11-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "<b>Cherry bomb</b> lemongrass cranberry spritzer shallots cookies potato overflowing berries cool off fall apricot blood orange smash. Hearts of palm heat arugula salad second course garlic sriracha noodles blueberry chia seed jam crunchy seaweed green onions hemp seeds raspberry fizz enchiladas green bowl double dark chocolate Mexican fiesta spicy pineapple salsa ultra creamy avocado pesto red amazon pepper chili peppermint tomato and basil. Blackberries cocoa parsley thyme lychee farro platter cool cucumbers peanut butter crunch burritos homemade balsamic cool lemon tahini dressing mint lime taco salsa eating together coriander cherry.<br/><br/>Street style Thai basil tacos Chinese five-spice powder overflowing Bulgarian carrot Thai curry Indian spiced Thai sun pepper blueberries plums red curry tofu noodles walnut mushroom tart blueberry pops tempeh almond milk bite sized. Chickpea crust pizza kale caesar salad crunchy orange pinch of yum scotch bonnet pepper roasted brussel sprouts açai simmer cauliflower picnic strawberry mango smoothie cherries vitamin glow rich coconut cream red lentil curry casserole veggie burgers alfalfa sprouts pomegranate lemon lime minty black bean chili dip.<br/><br/>Seitan summer fruit salad Sicilian pistachio pesto smoky maple tempeh glaze roasted butternut squash raspberries kale chili pepper sweet potato salted crumbled lentils ginger tofu ginger carrot spiced juice Bolivian rainbow pepper salad sriracha pecans cozy butternut creamiest green papaya salad sandwiches smoked tofu chai tea. Peaches hearty grains citrusy mediterranean sesame soba noodles butternut mix Southern Italian Thai dragon pepper avocado dressing drizzle broccoli chocolate cookie mushroom risotto tasty chocolate peanut butter dip sleepy morning tea artichoke hearts coconut rice vine tomatoes cremini mushrooms chia seeds cinnamon peach strawberry mango creamy cauliflower alfredo sauce mediterranean luxury bowl red grapes.<br/><br/>Balsamic vinaigrette maple orange tempeh green tea lime shiitake mushrooms samosa bento box grapefruit dessert almond milk chai latte cayenne banh mi salad rolls couscous. Red pepper ginger lemongrass agave green tea with cinnamon toast habanero golden four-layer pumpkin hazelnut shiitake jalapeño dill udon noodles a delicious meal ultimate dragon fruit avocado basil pesto ghost pepper fresh chocolate basil cilantro cilantro lime vinaigrette candy cane winter peanut butter fiery fruit winter soba noodles.",
					},
					{
						title: "HH-tickets are ready-go go go",
						when: "2024-01-01 08:00",
						short: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
						full: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec id leo luctus, mattis diam a, porta ex. Maecenas ornare est at aliquet facilisis. Pellentesque feugiat odio sed malesuada tempor. Nunc id pellentesque lacus. Nullam nisl magna, congue ut sapien ac, volutpat dapibus lorem. Etiam elit ligula, accumsan sit amet erat sit amet, laoreet consequat libero. Nam condimentum non mauris egestas condimentum. Nulla mauris turpis, congue in mauris at, malesuada tincidunt nunc. Morbi tincidunt rhoncus porttitor. Morbi maximus commodo convallis. Proin tempor dolor egestas, tincidunt nulla finibus, rutrum velit. Vestibulum lobortis semper neque, ut posuere orci. Morbi nec placerat purus, sit amet vulputate tortor.",
					},
				],
			},
		},
	},
	sponsors: {
		l5: [
			{
				name: "TRIA",
				url: "https://tria.hr",
				logo: "tria_no_text.png",
				// logoLight: "thera.png"
			},
			{
				name: "Factory X",
				url: "https://factory-x.hr",
				logo: "factory-x-logo.svg",
			},
			{
				name: "EBCONT",
				url: "https://www.ebcont.com/en",
				logo: "ebcont-base.png",
			},
			// { // @Nataša request - cancelled because they did not want to sign the contract - stupid :)
			// 	name: "REGEA",
			// 	url: "https://regea.org/",
			// 	logo: "regea-logo.png",
			// },
			{
				name: "HIWE-IT",
				url: "https://www.hiwe-it.com/",
				logo: "hiwe-it-light.svg",
			},
			{
				name: "cWebSpace",
				url: "https://cwebspace.hr",
				logo: "cwebspace-2.svg",
			},
			{
				name: "IPC",
				url: "https://www.ipc.hr/",
				logo: "ipc-logo-black.svg",
			},
			{
				name: "FranzNET",
				url: "https://franz-net.hr/",
				logo: "franz-net-novi-logo.png",
			},
			{
				name: "Printex",
				url: "https://printex.hr/",
				logo: "printex-logo-fb.png",
			},
			{
				name: "Humana Nova",
				url: "https://humananova.org/",
				logo: "humana_nova-logo2.png",
			},
			{
				name: "krtech",
				url: "https://www.krtech.digital/",
				logo: "krtech-black-transparent.svg",
			},
			{
				name: "FRAMOS",
				url: "https://www.framos.com/en/",
				logo: "framos-logo.svg",
			},
			{
				name: "Kourses",
				url: "https://kourses.com/",
				logo: "kourses-logo.svg",
			},
		],
		l4: [
			{
				name: "Full Circle",
				url: "https://www.facebook.com/fullcircle123",
				logo: "full-circle-logo.svg",
			},
			{
				name: "MIS",
				url: "https://udruga-mis.hr/",
				logo: "mis-logo.png",
			},
			{
				name: "makerspace",
				url: "https://makerspace.hr",
				logo: "makerspace.svg",
			},
			{
				name: "Darko Mareš",
				url: "https://www.darkomares.com/",
				logo: "darko-mares-logo.png",
			},
			{
				name: "rep.hr",
				url: "https://www.rep.hr/",
				logo: "rephr-logo.svg",
			}
		]
	},
	exhibitors: [
		// {
		// 	name: "makerspace",
		// 	url: "https://makerspace.hr",
		// 	logo: "makerspace.svg",
		// },
	],
	partners: {
		// accreditations: {
		// 	name: "cWebSpace",
		// 	url: "https://cwebspace.hr",
		// 	logo: "cwebspace-2.svg",
		// },
		// photo: {
		// 	name: "Darko Mareš",
		// 	url: "https://www.darkomares.com/",
		// 	logo: "darko-mares-logo.png",
		// }
	},
	__partners: {
		lunch: {
			name: "Algebra",
			url: "",
			logo: "algebra.svg",
		},
		coffee: {
			name: "ampnet",
			url: "",
			logo: "ampnet.svg",
		},
		snacks: {
			name: "Flow and Form",
			url: "",
			logo: "flow-and-form-dark.svg",
		},
		accreditations: {
			name: "laqo",
			url: "",
			logo: "laqo.svg",
		},
		water: {
			name: "Microsoft",
			url: "",
			logo: "microsoft.svg",
		},
		soft_drinks: {
			name: "TigerGraph",
			url: "",
			logo: "tigergraph.svg",
		},
		pens: {
			name: "revuto",
			url: "",
			logo: "revuto.png",
			visible: false,
		},
		notepads: {
			name: "Porsche",
			url: "",
			logo: "porsche.svg",
			visible: false,
		},
	},
	__mediaPartners: [
		{
			name: "toptal",
			url: "",
			logo: "toptal.svg",
		},
		{
			name: "veniture",
			url: "",
			logo: "veniture.svg",
		},
	],
	survey: { // generic survey questions (used only if event specific are not defined)
		visitors: [
			{ // OK
				required: true,
				question: { // this is used to generate "key" needed for internal logic
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				// description: { // additional info about the question, eq. clarification
				// 	hr: "Općenito organizacija i dojam koji je događaj ostavio na Vas.",
				// 	en: "General organization and the impression the event left on you."
				// },
				stars: true, // type
				// boolean: true, // type
				// comment: true, // type
				comment_opt: true, // optional comment
				// options: { // type
				// 	type: "checkbox", // checkbox or radio
				// 	items: [
				// 		{
				// 			value: "collegues",
				// 			hr: "Kolega u firmi",
				// 			en: "Colleagues in the company",
				// 		},
				// 	]
				// },
			},
			{ // OK
				required: true,
				event: ["weblica"], // for which event - generic if not given
				question: {
					hr: "Koliko ste zadovoljni ukupnom kvalitetom predavanja?",
					en: "How satisfied are you with the general quality of the sessions?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Što bismo mogli poboljšati?",
					en: "What could we improve on?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Da li je događaj ispunio vaša očekivanja?",
					en: "Did the event meet your expectations?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Kolika je vjerojatnost da ćete u budućnosti posjećivati ​​naše događaje?",
					en: "How likely would you be to attend our events in the future?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Biste li naše događaje preporučili prijatelju ili kolegi?",
					en: "Would you recommend our events to a friend or colleague?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Jeste li imali priliku i mjesto za postavljanje pitanja i sudjelovanje?",
					en: "Did you have an opportunity and place to ask questions and participate?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koliko ste bili zadovoljni pruženim mogućnostima umrežavanja?",
					en: "How satisfied were you with the networking opportunities provided?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Kako ste saznali za ovaj događaj?",
					en: "How did you hear about this event?",
				},
				options: {
					type: "checkbox",
					items: [
						{
							value: "colleague-friend",
							text: {
								hr: "Kolega/Prijatelj/Poznanik",
								en: "Colleague/Friend/Acquaintance",
							}
						},
						{
							value: "social-network",
							text: {
								hr: "Društvene mreže",
								en: "Social network",
							}
						},
						{
							value: "portal",
							text: {
								hr: "IT portal",
								en: "IT portal",
							}
						},
						{
							value: "newsletter",
							text: {
								hr: "Newsletter",
								en: "Newsletter",
							}
						},
						{
							value: "poster",
							text: {
								hr: "Plakat",
								en: "Poster",
							}
						},
						{
							value: "other",
							text: {
								hr: "Neki drugi način ...",
								en: "Some other way ...",
							}
						},
					],
				},
				comment_opt: true,
				comment_placeholder: {
					hr: "Ako ste saznali na neki drugi način, molimo da ovdje napišete kako?",
					en: "If you heard about this event in another way, please tell us how?",
				},
			},
			{ // OK
				question: {
					hr: "Jeste li već bili na ovom događaju?",
					en: "Have you attended this event before?",
				},
				boolean: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koliko Vam je osoblje bilo od pomoći?",
					en: "How helpful was the staff at the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koliko je platforma za događaj bila jednostavna za navigaciju?",
					en: "How easy-to-navigate was the platform for the event?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK - ADDED
				question: {
					hr: "Da li su oznake u i oko prostora bile dostatne za snalaženje?",
					en: "Were the markings in and around the event area sufficient for navigation?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koje biste teme voljeli vidjeti više na budućim događanjima?",
					en: "What topics would you want to see more of at future events?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Molimo podijelite sve dodatne komentare, misli, prijedloge za buduće događaje.",
					en: "Please share any additional comments, thoughts, suggestions for future events.",
				},
				comment: true,
			},
		],
		speakers: [
			{ // OK
				required: true,
				question: {
					hr: "Koliko ste općenito zadovoljni događajem?",
					en: "How satisfied were you with the event in general?",
				},
				stars: true,
				comment_opt: true,
			},
			{ // OK
				question: {
					hr: "Koje je bilo Vaše najdraže iskustvo ili trenutak događaja?",
					en: "What was your favorite experience or moment of the event?",
				},
				comment: true,
			},
			{ // OK
				question: {
					hr: "Gdje ste saznali da se možete prijaviti kao predavač na našoj konferenciji?",
					en: "Where did you find out that you can register as a lecturer at our conference?",
				},
				comment: true
			},
			{ // OK
				question: {
					hr: "Jesu li tehnička podrška i oprema zadovoljili vaše potrebe tijekom predavanja?",
					en: "Did the technical support and equipment meet your needs during the presentation?",
				},
				boolean: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Kako ocjenjujete organizaciju i komunikaciju s organizacijskim timom prije i tijekom konferencije?",
					en: "How do you rate the organization and communication with the organizing team before and during the conference?",
				},
				stars: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Kako biste ocijenili interes i angažman publike tijekom vašeg predavanja?",
					en: "How would you assess the interest and engagement of the audience during your presentation?",
				},
				stars: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Jesu li vam pružene dovoljne prilike za networking i interakciju s ostalim predavačima i sudionicima?",
					en: "Were you provided with sufficient opportunities for networking and interaction with other speakers and participants?",
				},
				boolean: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Postoji li nešto što bi moglo biti poboljšano u vezi s vašim iskustvom na konferenciji?",
					en: "Is there anything that could be improved in relation to your experience at the conference?",
				},
				comment: true
			},
			{ // OK
				required: true,
				question: {
					hr: "Biste li se željeli vratiti kao predavač na budućim izdanjima naše konferencije?",
					en: "Would you like to return as a speaker at future editions of our conference?",
				},
				boolean: true,
				comment_opt: true
			},
			{ // OK
				question: {
					hr: "Imate li preporuke za teme ili sadržaje koji bi mogli obogatiti buduća izdanja naše konferencije?",
					en: "Do you have any recommendations for topics or content that could enrich future editions of our conference?",
				},
				comment: true
			},
		],
	},
}